import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, ViewChild, signal } from '@angular/core';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { BCMCLPUser, TeamCodes } from '../../models/clpuser.model';
import { CMClub, CMClubResponse, CMSite, CMSiteEmployees, CMSiteEmployeesAccept, CMSiteEmployeesListResponse, SiteDDListResponse } from '../../models/cm-club-service.model';
import { DropDownItem, IntDropDownItem, SimpleResponse } from '../../models/generic-response.model';
import { CMBoatClasses, CMBoatClassesResponse, Fee, Product, ProductResponse, SimpleProduct } from '../../models/product.model';
import { GlobalService } from '../../services/shared/global.service';
import { LocalService } from '../../services/shared/local.service';
import { UtilityService } from '../../services/shared/utility.service';
import * as $ from "jquery";
import { AutoCompleteComponent, DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { eUserRole } from '../../models/enum.model';
import { CMContractService } from '../../services/cm-contract.service';
import { MembershipService } from '../../services/membership.service';
import { CMClubService } from '../../services/cm-club.service';
import { CMContractMember, Contact, ContactDetails, CMContract, ContractResponse, CMContractSetting, CMContractSettingResponse, CMMemberStatus, CMContractFeeListResponse, CMContractFee, CMMemberFeeListResponse, CMMemberFee, FeeButton, ContractPdfConvertContainer, CMContractLog, eREF_CMContractStatus, eREF_CMMemberStatus, REF_CMStatusResponse, REF_CMStatus, REF_CMStatusSorted, CMAddMemberFee } from '../../models/cm-contract';
import { ProductService } from '../../services/product.service';
import { FormatSettings } from '@progress/kendo-angular-dateinputs';
import { NotificationService } from '../../services/notification.service';
import { CountryStateService } from '../../services/country-state.service';
import { Search, SearchListResponse } from '../../models/search.model';
import { SearchContactService } from '../../services/shared/search-contact.service';
import { DatePipe } from '@angular/common';
import { CountryPlaceholder } from '../../models/country-state.model';
import { CountryCode } from 'libphonenumber-js';
import {  SafeUrl, Title } from '@angular/platform-browser';
import { PaymentService } from '../../services/payment.service';
import { AppConfigService } from '../../services/shared/app-config.service';
import { ConfigDetails } from '../../models/app-config.model';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerInputEvent, MatDatepicker } from '@angular/material/datepicker';
import { SignaturePad } from 'angular2-signaturepad';
import { REFMem_GetAllResponse, REF_MemAssociationToPrimaryCaptain } from '../../models/membership.model';
import { SessionService } from '../../services/shared/session.service';

//import { filter } from '@progress/kendo-angular-editor/util';
//import { isNullOrUndefined } from 'util';
declare var $: any;

@Component({
    selector: 'app-cm-contract',
    templateUrl: './cm-contract.component.html',
    styleUrl: './cm-contract.component.css',
    providers: [provideNativeDateAdapter()],

})
export class CmContractComponent implements AfterViewInit {
    agentForm: FormGroup;
    siteTaxForm: FormGroup;
    numPaymentsForm: FormGroup;
    termForm: FormGroup;
    paymentForm: FormGroup;
    contactForm: FormGroup;
    contactForm2: FormGroup;
    textForm: FormGroup;
    testModeForm: FormGroup;
    upgradeForm: FormGroup;
    contractTypeForm: FormGroup;
    initialFinalSignature: string = "";
    initialFinalDisabled: boolean = false;
    @ViewChild('autocomplete') autocomplete: AutoCompleteComponent;
    @ViewChild('sigpadFinal', { static: true }) signaturePadFinal: SignaturePad;
    contactId: number = 0;
    fromContactId: number = 0;
    encryptedUser: string = ''
    user: BCMCLPUser;
    mailMergeTemplateList: IntDropDownItem[];
    cMProductUnused: SimpleProduct[];
    curSite: CMSite = <CMSite>{}
    curTeam: TeamCodes = <TeamCodes>{};
    curSiteSub: Subscription;
    clubConfig: CMClub;
    productList: Product[];
    all_productList: Product[];
    product: Product = <Product>{}
    /*    countryDD: DropDownItem[];*/
    stateList: DropDownItem[];
    countryDD: CountryPlaceholder[];
    clubId: number = 0;
    isContractReview: boolean = false;
    subDomain: string = '';
    resnet_url: string = '';
    isReview: boolean = false;
    filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains',
    };
    placeHolder: string = "";
    mobile_mask: string = '(000) 000-0000';
    selectedAgreements: number[] = [];
    selectedRules: number[] = [];
    siteList: CMSite[];
    site: CMSite = <CMSite>{};
    clpCompanyId: number;
    contracts: CMContract[] = [];
    contract: CMContract = <CMContract>{};
    contractMember: CMContractMember = <CMContractMember>{};
    //contact: ContactDetails = <ContactDetails>{};;
    contacts: ContactDetails[];
    siteId: number = -1;
    classCode1: number = 0;
    class1CodePrimary: number = 0;
    public siteSelected: number;
    public siteSelectedName: string;
    public productSelected: number;
    public upgradeSelected: number;
    public productSelectedName: string;
    memberFee: number = 0;
    memberFeeTax: any = 0;
    signupFee: number = 0;
    signupFeeTax: any = 0;
    totalSignupFee: number = 0;
    totalMemberFee: number = 0;
    sites: CMSite[];
    contactDetails: any = [];
    public format: FormatSettings = {
        displayFormat: 'MM/dd/yyyy',
        inputFormat: 'MM/dd/yy'
    };
    public signataurePadOptions = {
        'minWidth': 1,
        'maxWidth': 2,
        'minHeight': 150,
        'maxHeight': 200,
        penColor: 'black',
        backgroundColor: '#fff',
    };
    dtDate: Date = new Date();
    dtStartDate: Date = new Date();
    dtBeginDate: Date = new Date();
    dtEndDate: Date = new Date();
    dtDOB: Date = new Date();

    isContactCreate: boolean = false;
    new_contact: boolean = false;

    countryCode: string = "US";
    stateCode: string = "";
    searchList: Search[] = [];
    inputBoxValue: string = "";
    contractId: number = 0;
    contactData: Contact = <Contact>{};
    contractEdit: boolean = false;
    dtSign: any;
    //dtCNStart: Date = new Date();
    //dtPayBegin: Date = new Date();
    //dtCntExp: Date = new Date();
    memberFeeUpdated: number;
    signupFeeUpdated: number;
    isSeasonal: boolean = false;
    isDays: boolean = false;
    isEveryday: boolean = false;

    ContractSetting: CMContractSetting = <CMContractSetting>{};
    placeholder: string = "";
    memContactId: number;
    delContactId: number;
    membersForm: FormGroup
    emailTxtMsg: boolean = false;
    contractFees: CMContractFee[];
    memberFeeList: CMMemberFee[];
    feeButtonList: FeeButton[] = [];
    siteEmployeesList: CMSiteEmployees[];
    isValidFee: boolean = true;
    isValidFinalFee: boolean = true;
    isMemberExist: boolean;
    taxRate: number;
    isEditMem: boolean = false
    intMaxMembers: number = 0;
    dltMemIndex: number = 0;
    isPaymentDone: number = 0;
    showSpinner: boolean;

    txtContactId: number = 0;
    txtContact_i: number = 0;
    bcmSiteUrl: string;

    phSendContractMessageText: string = '';
    phSendContractMediaURL: string = '';
    contractStatusId: number = 0;
    contractStatusIdAdmin: number = 0;
    isDownloaded: boolean;
    isDownloadedDL: boolean;
    isSignVisible: boolean = false;
    isSubscribe: any;
    isSubscribeDL: any;
    contractPdfConvertContainer: ContractPdfConvertContainer;
    contractPdfConvertContainerDL: ContractPdfConvertContainer;

    mySoLink: string = '';
    signOfficerEmpId: number = 0;
    isContractManager: boolean = false;
    cmContactId: number;
    primaryContactName: string = '';
    readonly panelOpenState = signal(false);
    disableSaveContract: boolean = false;
    isShowReview: boolean = false;
    contractAuditorList: CMSiteEmployees[];

    depositSummary: string = '';
    isSignUpdate: boolean = true;
    PrimaryCTuserID: number = 0;
    admin_override: boolean = false;
    is_transfer: boolean = false;
    contractStatuses: REF_CMStatus[];
    memberStatuses: REF_CMStatus[];
    contractTypes: REF_CMStatus[];
    contractTypesFull: REF_CMStatus[];
    actionTypesReset: REF_CMStatusSorted[] = [
        { statusID: 0, sOrder: 1, status: '--Select--' },
        { statusID: 1, sOrder: 2, status: 'Create New' },           //NOT ACTIVE
        { statusID: 2, sOrder: 4, status: 'Renew' },                //ACTIVE
        { statusID: 3, sOrder: 3, status: 'Change' },              //ACTIVE
        { statusID: 4, sOrder: 5, status: 'Add Paying Member' },    //ACTIVE
        { statusID: 5, sOrder: 10, status: 'Change' },    //ACTIVE
        { statusID: 6, sOrder: 7, status: 'Mark as Transfer' },     //ACTIVE
        { statusID: 7, sOrder: 8, status: 'Create New Transfer' },  //NOT ACTIVE
        { statusID: 8, sOrder: 6, status: 'Add Non-Paying Member' },//BOTH
        { statusID: 9, sOrder: 9, status: 'Terminate' },            //BOTH ---> so for ACTIVE, follows UPGRADE -> they select TERMINATE. DON't put into Deposit table.
        //{ statusID: 11, sOrder: 10, status: 'RESNET Add Member' },  //NOT ACTIVE
        //{ statusID: 5, sOrder: 11, status: 'RESNET Renew' },        //NOT ACTIVE
        //{ statusID: 10, sOrder: 12, status: 'RESNET Existing' },    //NOT ACTIVE
    ];

    actionTypes: REF_CMStatusSorted[] = [];
    imageSrc: SafeUrl | null = null;
    isSignLoaded: boolean;
    
    relationshipStatus: REF_MemAssociationToPrimaryCaptain[];
    api_log_visible: boolean = false;

    disable_accept: boolean = false;
    disable_send: boolean = false;
    contractTypeID: number = 1;
    reservationID: string = '';
    reservationAccountStatus: string = '';
    actionTypeID: number = 0;
    contractType: string = 'New';
    upgradeConfirmed: boolean = false;
    changeConfirmed: boolean = false;
    cmBoatClasses: CMBoatClasses[];
    changeContractPlan: boolean = false;

    addPMConfirmed: boolean = false;
    renewConfirmed: boolean = false;
    terminateConfirmed: boolean = false;
    /** Set to true after the user confirms that saving will invalidate existing signatures. */
    resetSignaturesConfirmed: boolean = false;
    /** Set to true after the user acknowledges the warning that one or more members are missing email/mobile. */
    contactInfoWarningAcknowledged: boolean = false;

    addPMDtSigned: string = '';
    renewDtSigned: string = '';
    contractEndDate: string = '';
    contractTerm: string = '';
    contractTerm2: string = '';
    contractPaymentBegins: string = '';
    contractStartDate: string = '';
    originalContractFinalPayment: string = '';
    resnet_change: boolean = false;
    resnet_renew: boolean = false;
    resnet_addpaying: boolean = false;
    hidePad: boolean = true;
    paying: string = 'paying ';
    resnet_contract: string = '';

    private destroy$ = new Subject<void>();
    minDate: Date;

    constructor(private localService: LocalService,
        private fb: FormBuilder,
        private _router: Router,
        private _route: ActivatedRoute,
        private _utilityService: UtilityService,
        private _globalService: GlobalService,
        private _contractService: CMContractService,
        private _membershipService: MembershipService,
        private _clubService: CMClubService,
        private titleService: Title,
        private _productService: ProductService,
        private _notifyService: NotificationService,
        private _countryStateService: CountryStateService,
        private _searchContactService: SearchContactService,
        private _paymentService: PaymentService,
        private _appconfigService: AppConfigService,
        public datepipe: DatePipe,
        private _sessionService: SessionService,
    ) {
        this.titleService.setTitle('Contract Manager');
        this.localService.setShowMenu(true);
        this.localService.setIsContract(true);
        this.localService.setIsCmSite(false);
        this.localService.setIsCmManager(false);
        this.localService.setIsMembership(false);
        this.localService.setRouteName("cm-contract");

        const today = new Date();
        today.setHours(0, 0, 0, 0);  // remove time portion
        this.minDate = today;
    }

    async ngOnInit() {
        this.agentForm = this.prepareAgentForm();
        this.numPaymentsForm = this.prepareTermForm();
        this.termForm = this.prepareTermForm();
        this.siteTaxForm = this.prepareSiteTaxForm();
        this.paymentForm = this.preparePaymentForm();
        this.contactForm = this.prepareContactForm();
        this.contactForm2 = this.prepareContactForm2();
        this.membersForm = this.prepareMemberForm();
        this.textForm = this.prepareTextForm();
        this.testModeForm = this.prepareTestModeForm();
        this.upgradeForm = this.prepareUpgradeForm();
        this.contractTypeForm = this.prepareContractTypeForm();

        const queryParams = this._route.snapshot.queryParams;
        const params = this._route.snapshot.params;
        this.contactId = +params['contactId'];
        this.fromContactId = this.contactId;

        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key.startsWith("mrid:")) {
                localStorage.removeItem(key);
            }
        }

        this.encryptedUser = await this._sessionService.getSession();

        if (this.encryptedUser) {
            localStorage.setItem("token", this.encryptedUser);
        }

        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {
                    localStorage.setItem("token", this.encryptedUser);
                    this.cmContractStatus_GetList();
                    this.cmContractType_GetList();
                    this.actionTypes_GetList();
                    this.cmMemberStatus_GetList();
                    this.memRelationships_GetList();
                    this.getCMClassList();

                    this.addTimeout(() => {
                        this.refreshContract();
                    }, 200);

                    this._appconfigService.mySO_Site_URL()
                        .pipe(takeUntil(this.destroy$)).subscribe(async (result: ConfigDetails) => {
                            if (result) {
                                this.mySoLink = result?.configValue
                            }
                        });
                }
                else {
                    this._appconfigService.mySO_Site_URL()
                        .pipe(takeUntil(this.destroy$)).subscribe(async (result: ConfigDetails) => {
                            if (result) {
                                this.mySoLink = result?.configValue;
                                localStorage.setItem("token", '');
                                window.location.href = this.mySoLink + `?cid=${this.contactId}&cm=1`;
                            }
                        });
                }
            });
        }
        else {
            this._appconfigService.mySO_Site_URL()
                .pipe(takeUntil(this.destroy$)).subscribe(async (result: ConfigDetails) => {
                    if (result) {
                        this.mySoLink = result?.configValue;
                        localStorage.setItem("token", '');
                        window.location.href = this.mySoLink + `?cid=${this.contactId}&cm=1`;
                    }
                });

        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();

        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }

    ngAfterViewInit(): void {
        this.addTimeout(() => {
            this.resizeCanvas();
        }, 2000)

    }

    async saveSignature() {
        this.disable_accept = true;

        let esignCapture: string = '';
        if (this.isSignVisible && this.signaturePadFinal?.isEmpty() == false) {
            esignCapture = this.signaturePadFinal.toDataURL('image/png');
        }
        else {
            esignCapture = "";
        }
        if (this.isSignVisible) {
            let penned = esignCapture != '';
            let keyed = this.initialFinalSignature != '';
            if (!penned && !keyed) {
                this._notifyService.showError("Please sign the document.", "", 10000);
                this.disable_accept = false;
                return;
            }
        }
        if (this.siteEmployeesList.some(s => s.roleName.toLowerCase() == 'signing officer' && s.userID == this.user?.cLPUserID) == true) {
            let empId = this.siteEmployeesList.filter(s => s.userID == this.user?.cLPUserID && s.roleName.toLowerCase() == 'signing officer' && (s.siteID == this.siteId || s.siteID == 0))[0]?.iD;
            if (empId == null && empId == undefined) {
                empId = this.siteEmployeesList.filter(s => s.roleName.toLowerCase() == 'signing officer' && s.userID == this.user?.cLPUserID)[0]?.iD;
            }
            let empAccept = {} as CMSiteEmployeesAccept;
            empAccept.cmEmployeeID = empId;
            empAccept.cLPUserId = this.user.cLPUserID;
            empAccept.contactId = this.contactId;
            empAccept.sCLPUserId = this.user?.slurpyUserId > 0 ? this.user?.slurpyUserId : 0;
            empAccept.cmContractID = this.contractId;
            empAccept.isFaceToFace = -1;
            empAccept.eSigFullImage = esignCapture;
            empAccept.eSigLength = 0;
            empAccept.cLPCompanyID = this.user?.cLPCompanyID;
            empAccept.eFullName = this.initialFinalSignature;
            this.showSpinner = true;
            await this._contractService.CMSiteEmployees_SignAccepted(this.encryptedUser, empAccept, this.isSignUpdate)
                .then(async (result: SimpleResponse) => {
                    if (result?.messageBool) {
                        this.Log(`Contract Status changed to <b>Active</b>.`);

                        this.refreshContract();
                        this._notifyService.showSuccess("Signature saved successfully.", "", 7000);
                        this.isReview = true;

                        if (!result?.messageBool2) {
                            this._notifyService.showError(result?.messageString, "Reservation Error", 15000);
                        }
                    }
                    this.showSpinner = false;
                    this.disable_accept = false;
                })
                .catch((err: HttpErrorResponse) => {
                    this.showSpinner = false;
                    this._globalService.error("cm-contract.saveSignature", err.message, null);
                    this._utilityService.handleErrorResponse(err);
                    this.disable_accept = false;
                });
        }
        else {
            this.isSignVisible = false;
            this.disable_accept = false;
        }
    }

    signatureFinalOnEnd() {
        if (this.signaturePadFinal?.isEmpty() == false) {
            this.initialFinalDisabled = true;
        }
    }

    clearSign() {
        this.hidePad = false;
        this.addTimeout(() => {
            this.resizeCanvas();
        }, 500)
        this.isSignUpdate = true;
        this.initialFinalDisabled = false;
        this.initialFinalSignature = "";
        this.drawClearFinal();
    }

    drawClearFinal(): boolean {
        this.signaturePadFinal.clear();
        this.signaturePadFinal.on();
        return false;
    }
    resizeCanvas() {
        var canvas = document.getElementsByTagName("canvas")[0];
        if (canvas) {
            var outer = document.getElementsByClassName("signature-pad");
            canvas.width = outer[0].clientWidth;
            canvas.height = 200;
        }
    }

    async dtSignedMembers_Update() {
        await this._contractService.dtSignedMembers_Update(this.encryptedUser, this.contractId)
            .then(async (result: SimpleResponse) => {
                if (result) {

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.dtSignedMembers_Update", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }


    async refreshContract(isPrimary = false) {
        this.showSpinner = true;

        this.contractType = 'New';

        this.contractTypeForm.patchValue({
            contractType: this.contractType,
        });

        await this.dtSignedMembers_Update()
        this.getBCMBaseUrl()
        this.getCountry();
        this.getCountryStateList(this.countryCode);
        this.getInitialContact(isPrimary);
        this.agentForm.patchValue({
            agentName: this.user.firstName + " " + this.user.lastName
        });
        this.numPaymentsForm.patchValue({
            term: ''
        });
        this.termForm.patchValue({
            term: ''
        });

        this.addTimeout(() => {
            this.showSpinner = false;
        }, 7000)
    }

    //#region prepare forms

    prepareMemberForm() {
        return this.fb.group({
            members: this.fb.array([this.addMember()]),
        })
    }

    addMember(): FormGroup {
        return this.fb.group({
            firstName: [''],
            lastName: [''],
            add1: [''],
            city: [''],
            state: [''],
            zip: [''],
            email: [''],
            mobile: [''],
            signupFee: [''],
            membershipFee: [''],
            memberFees: this.fb.array([this.addMemberFees()]),
            contactId: [''],
            statusId: [0],
            statusIdAdmin: [0],
            cMMemberID: [0],
            isPrimary: [false],
            isF2FLinkCopied: [false],
            isExtraMem: [false],
            dtDL: new Date(),
            relationship: ['']
        });
    }

    addMemberFees() {
        return this.fb.group({
            cMContractFeeID: new FormControl(0),
            cmProductFeeID: new FormControl(0),
            cmProductID: new FormControl(0),
            cmMemberFeeID: new FormControl(0),
            cMFeeName: new FormControl(""),
            feeTotal: new FormControl(0),
            feeBase: new FormControl(0),
            feeTax: new FormControl(0),
            isTaxable: new FormControl(0)
        })
    }

    prepareAgentForm() {
        return this.fb.group({
            agentName: ['']
        })
    }

    prepareTestModeForm() {
        return this.fb.group({
            processorTestMode: [false]
        })
    }

    prepareUpgradeForm() {
        return this.fb.group({
            alreadyPaid: [''],
            alreadyPaidTax: [''],
            alreadyPaidIsTaxable: [false],
            dtAlreadyPaid: [''],
            upgradeSelected: [0]
        })
    }

    prepareContractTypeForm() {
        return this.fb.group({
            contractType: ['New']
        })
    }

    prepareTermForm() {
        return this.fb.group({
            term: ['']
        })
    }

    getBCMBaseUrl() {
        this._appconfigService.bCMGetConfigKeyValue(this.encryptedUser, "bcmsite")
            .pipe(takeUntil(this.destroy$)).subscribe(async (result: ConfigDetails) => {
                if (result) {
                    this.bcmSiteUrl = result?.configValue
                }
            });
    }

    prepareSiteTaxForm() {
        let expires = this.addDays(this.dtStartDate, 7);
        let end = this.addMonthsContract(this.dtBeginDate, 12);

        return this.fb.group({
            SignupFee: ['', [Validators.required]],
            SignupFeeTax: [''],
            MembershipFee: ['', [Validators.required]],
            MembershipFeeTax: [''],
            fees: this.fb.array([]),
            dtSignedMembers: [''],
            reservationID: [''],
            contractStart: [this.dtStartDate],
            contractStartLabel: [this.getFormattedDate(this.dtStartDate)],
            contractEnd: [end],
            contractEndLabel: [this.getFormattedDate(end)],
            paymentBegin: [this.dtBeginDate],
            paymentBeginLabel: [this.getFormattedDate(this.dtBeginDate)],
            paymentEnd: [end],
            paymentEndLabel: [this.getFormattedDate(end)],
            contractExpires: [expires],
            contractExpiresLabel: [this.getFormattedDate(expires)],
            specialterms: [''],
            productDesc: [''],
            isJanuary: [false],
            isFebruary: [false],
            isMarch: [false],
            isApril: [false],
            isMay: [false],
            isJune: [false],
            isJuly: [false],
            isAugust: [false],
            isSeptember: [false],
            isOctober: [false],
            isNovember: [false],
            isDecember: [false],
            isMonday: [false],
            isTuesday: [false],
            isWednesday: [false],
            isThursday: [false],
            isFriday: [false],
            isSaturday: [false],
            isSunday: [false]
        })
    }

    preparePaymentForm() {
        return this.fb.group({
            isEntryACH: [false],
            isEntryCC: [false],
            isEntryCheck: [false],
            isEntryCash: [false],
            isMonthlyACH: [false],
            isMonthlyCC: [false],
            isMonthlyCheck: [false],
            isAffirmEntry: [false]
        })
    }

    prepareContactForm() {
        return this.fb.group({
            txtFirstName: [{ value: '' }, [Validators.required]],
            txtLastName: [{ value: '' }, [Validators.required]],
            txtEmail: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/)]],
            txtMobilePhone: ['', [Validators.required]],
            txtHomePhone: [{ value: '' }],
            txtAddress: [{ value: '' }],
            txtCity: [{ value: '' }],
            txtZip: [{ value: '' }, [Validators.minLength(5), Validators.maxLength(9)]],
            contactId: [{ value: 0 }],
            country: ['US'],
            state: ['']
        })
    }

    prepareContactForm2() {
        return this.fb.group({
            dl: [{ value: '' }],
            dob: [''],
            emgContactName: [{ value: '' }],
            txtEmgCntPhone: [{ value: '' }],
            site: [{ value: this.siteSelectedName }],
            siteId: [this.siteSelected],
            relationshipID: [2],
            explain: [{ value: '' }],
            isPrimary: [true]
        })
    }

    validateNumber(event: KeyboardEvent) {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            event.preventDefault();
        }
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched();
                control.updateValueAndValidity();

                if (!control.valid && !control.disabled) {
                    this._notifyService.showError(field, control.value + ' is invalid.', 10000);
                }
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    private async authenticateR() {
        await this.localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    this.api_log_visible = this.user?.userRole >= eUserRole.Administrator;

                    if (result?.strToken && result?.strToken != '') {
                        this.encryptedUser = result?.strToken;
                    }
                    this.clpCompanyId = this.user?.cLPCompanyID;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    //#endregion

    //#region dropdown activity

    async getCountry() {
        await this._countryStateService.getListWithPlaceholder(this.encryptedUser)
            .then(async (result: CountryPlaceholder[]) => {
                if (result) {
                    this.countryDD = UtilityService.clone(result);
                    this.countryDD?.unshift({
                        country_Code: "",
                        country_Name: "--Select--",
                        placeholder: "",
                        country_Code2: ""
                    });
                    this.onChangeCountry(this.countryCode)
                }

            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    onChangeCountry(countryCode) {
        this.stateCode = ""
        this.getCountryStateList(countryCode)
        var country_Code = this.countryDD.filter(x => x.country_Code == countryCode)[0]?.country_Code;
        this.placeholder = this.countryDD.filter(x => x.country_Code == countryCode)[0]?.placeholder;

        if (country_Code && this.placeholder) {
            this.placeHolder = this._countryStateService.parseSimplePhone(this.placeholder, country_Code as CountryCode);
            this.mobile_mask = this._countryStateService.replaceZero(this.placeHolder);
        }
    }

    async getCountryStateList(countryCode: string) {
        await this._countryStateService.getCountryStateList(this.encryptedUser, countryCode ? countryCode : "US")
            .then(async (result: DropDownItem[]) => {
                if (result) {
                    this.stateList = UtilityService.clone(result);
                    this.stateList?.unshift({
                        value: "",
                        text: "--Select--",
                        isSelected: false
                    });
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    //#endregion

    //#region contact

    async getPrimaryContactDetails(contactid: number) {
        await this._contractService.LoadContractMemberDisplay(this.encryptedUser, contactid).
            then(async (result: any) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response) {

                        this.contactData.cLPUserID = response.clpuserID;
                    }
                }
                else {
                    this._notifyService.showError("This contact is not assigned with an active site.", "", 10000);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getPrimaryContactDetails", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getContactDetails(callback, isPrimary) {
        await this._contractService.LoadContractMemberDisplay(this.encryptedUser, isPrimary ? this.fromContactId : this.contactId).
            then(async (result: any) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response) {
                        if (callback) {
                            callback(response);
                        }
                    }
                }
                else {
                    this._notifyService.showError("This contact is not assigned with an active site.", "", 10000);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getContactDetails", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getInitialContact(isPrimary) {
        this.getContactDetails((response) => {
            this.contactDetails = [];
            this.depositSummary = response.depositSummary;
            this.contactDetails.push(response);
            this.classCode1 = response.class1Codes;
            this.class1CodePrimary = response.class1Codes;
            this.primaryContactName = `${response.firstName} ${response.lastName}`;
            this.titleService.setTitle(this.primaryContactName);
            this.getSiteData();
        }, isPrimary);
    }

    async getClubDetails() {
        await this._clubService.clubGetByID(this.encryptedUser, this.clubId).
            then(async (result: CMClubResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.isContractReview = response.clubConfig?.isContractReview;
                    this.subDomain = response.clubConfig?.custom3;
                    this.resnet_url = `https://${this.subDomain}.reservemyboat.com/en/staff/accounts/`;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getClubDetails", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getContactData(isRefresh: boolean = false, callback) {
        this.getContactDetails((response) => {
            this.contactDetails = [];
            this.contactDetails.push(response);
            this.classCode1 = response.class1Codes;
            this.buildContactList(isRefresh);
            if (callback) {
                callback();
            }
        }, false);
    }

    async getContactById(_contactId: number, isPrimary: boolean) {
        this.getContactDetails((response) => {
            this.contactDetails.push(response);
            this.isContactCreate = true;
            this.patchContact(response, isPrimary);

            this.Log(`Contact (${response.firstName} ${response.lastName}: ${_contactId}) selected.`);
        }, false);
    }

    buildContactList(isRefresh: boolean = false, isChangePlan: boolean = false) {
        if (this.contacts == null || this.contacts == undefined) {
            this.contacts = [];
        }

        let isPrimary: boolean = false;
        let arrMembers = this.contracts[0]?.members.filter(x => x.isPrimary == true);
        if (arrMembers != null && arrMembers.length > 0) {
            isPrimary = true;
        }

        this.contactDetails.forEach((c) => {
            let contact: ContactDetails = {
                contactId: c.contactID,
                add1: c.add1,
                city: c.city,
                country: c.country,
                state: c.state,
                zip: c.zip,
                mobile: c.mobile,
                homePhone: c.homePhone,
                firstName: c.firstName,
                lastName: c.lastName,
                email: c.email,
                signupFee: c.signupFee,
                memberFee: c.memberFee,
                custom4: c.custom4,
                custom5: c.custom5,
                custom6: c.custom6,
                custom7: c.custom7,
                dl: c.dl,
                dob: c.dob,
                emergencyCName: c.emergencyCName,
                emergencyCPhone: c.emergencyCPhone,
                cMMemberID: (this.contracts[0]?.members.filter(x => x.contactID == c.contactID)[0]?.cMMemberID) ? this.contracts[0]?.members.filter(x => x.contactID == c.contactID)[0]?.cMMemberID : 0,
                cMIsPrimary: (this.contracts[0]?.members.filter(x => x.contactID == c.contactID)[0]?.isPrimary) ? this.contracts[0]?.members.filter(x => x.contactID == c.contactID)[0]?.isPrimary : ((this.fromContactId == c.contactID && isPrimary == false) ? true : false),
                statusId: this.contracts[0]?.members.filter(x => x.contactID == c.contactID)[0]?.statusID,
                statusIdAdmin: this.contracts[0]?.members.filter(x => x.contactID == c.contactID)[0]?.statusID,
                dtDL: this.contracts[0]?.members.filter(x => x.contactID == c.contactID)[0]?.dtDL,
                site: c.site,
                siteID: c.siteID
            };
            if (this.contacts.some(cnt => cnt.contactId == c.contactID) == false)
                this.contacts.push(contact);
            else {
                this.contacts.forEach((item) => {
                    if (item.contactId == c.contactID) {
                        item.add1 = contact.add1;
                        item.city = contact.city;
                        item.country = contact.country;
                        item.state = contact.state;
                        item.zip = contact.zip;
                        item.mobile = contact.mobile;
                        item.homePhone = contact.homePhone;
                        item.firstName = contact.firstName;
                        item.lastName = contact.lastName;
                        item.email = contact.email;
                        item.signupFee = contact.signupFee;
                        item.memberFee = contact.memberFee;
                        item.custom4 = contact.custom4;
                        item.custom5 = contact.custom5;
                        item.custom6 = contact.custom6;
                        item.custom7 = contact.custom7;
                        item.statusId = contact.statusId;
                        item.statusIdAdmin = contact.statusIdAdmin;
                        item.cMMemberID = contact.cMMemberID;
                        item.dl = contact.dl;
                        item.dob = contact.dob;
                        item.emergencyCName = contact.emergencyCName;
                        item.emergencyCPhone = contact.emergencyCPhone;
                        item.dtDL = contact.dtDL;
                        item.site = contact.site;
                        item.siteID = contact.siteID;
                    }
                });
            }
        });

        this.contacts = this.contacts.sort(({ cMIsPrimary: a = false }, { cMIsPrimary: b = false }) => Number(b) - Number(a));

        this.members.controls = [];
        this.members.removeAt(0);

        if (this.contacts?.length > 0) {
            //this.contacts = this.toSetPrimaryMemAtFirst(this.contacts);
            this.contacts?.forEach(async (element, index) => {

                let memFee: CMMemberFee[] = [];
                let member: CMContractMember = <CMContractMember>{}
                if (this.contracts[0]?.members?.some((item) => item.cMMemberID == element?.cMMemberID) == true) {
                    member = this.contracts[0]?.members?.filter((item) => item.cMMemberID == element?.cMMemberID)[0];
                    memFee = member?.CMMemberFees;
                }
                if (memFee && memFee?.length == 0 || isChangePlan) {
                    memFee = [];

                    if (!isChangePlan) {
                        this.contracts[0]?.members[0]?.CMMemberFees.forEach((item) => {
                            let memberFeeID = 0;

                            if (item?.memberID > 0) {
                                memberFeeID = item?.cmMemberFeeID;
                            }

                            let obj = {
                                cmContractFeeID: item?.cmContractFeeID,
                                cmProductFeeID: item?.cmProductFeeID,
                                cmProductID: item?.cmProductID,
                                cmMemberFeeID: memberFeeID,
                                cmFeeName: item?.cmFeeName,
                                feeTotal: item?.feeTotal,
                                feeTax: 0,
                                feeSurcharge: 0,
                                isTaxable: item?.isTaxable,
                                isRecurring: item?.isRecurring,
                                memberID: item?.memberID,
                                contactID: 0,
                                sOrder: item?.sOrder,
                                feeBase: 0,
                                isDone: false,
                                memberSplitable: 0,
                                isPrimary: false,
                                isPaymentSplitable: item?.isPaymentSplitable,
                                isCCOverride: item?.isCCOverride,
                                isCollectNow: item?.isCollectNow,
                                isRequirePM: item?.isRequirePM,
                                vSubscriptionID: item?.vSubscriptionID
                            }
                            memFee.push(obj)
                        });
                    }

                    //if no member fee exists, pull it from product 
                    if (memFee.length == 0) {
                        if (this.product?.fees?.length > 0) {
                            this.product?.fees.forEach((fee, index) => {
                                let surcharge_rate = fee?.isRecurring ? (this.ContractSetting.ccRFee / 100) : (this.ContractSetting.ccNRFee / 100);
                                let fee_tax = Math.round(this.changeToNumber(fee.feeAmount.toString()) * (this.site.taxRate / 100));
                                let surcharge = fee?.isTaxable ? ((fee?.feeAmount + fee_tax) * surcharge_rate) : (fee?.feeAmount * surcharge_rate);

                                this.ContractSetting.ccRFee
                                let obj = {
                                    cmContractFeeID: 0,
                                    cmProductFeeID: fee?.cmProductFeeID,
                                    cmProductID: fee?.cmProductID,
                                    cmMemberFeeID: 0,
                                    cmFeeName: fee?.cmFeeName,
                                    feeTotal: 0,
                                    feeTax: fee_tax,
                                    feeSurcharge: surcharge,
                                    isTaxable: fee?.isTaxable,
                                    isRecurring: fee?.isRecurring,
                                    memberID: 0,
                                    contactID: 0,
                                    sOrder: fee?.sOrder,
                                    feeBase: this.fromContactId == element.contactId ? fee?.feeAmount : 0,
                                    isDone: false,
                                    memberSplitable: 0,
                                    isPrimary: false,
                                    isPaymentSplitable: fee?.isPaymentSplitable,
                                    isCCOverride: fee?.isCCOverride,
                                    isCollectNow: fee?.isCollectNow,
                                    isRequirePM: fee?.isRequirePM,
                                    vSubscriptionID: ''
                                }
                                memFee.push(obj)
                            });
                        }
                    }
                }

                memFee = memFee.sort((a, b) => a.sOrder - b.sOrder);

                let mrid = localStorage.getItem(`mrid:${element.contactId}`);

                let relationshipID: number = 2;
                let relationship = '';
                let explain = '';

                if (mrid) {
                    relationshipID = +mrid;
                    relationship = this.relationshipStatus.find(item => item.statusID === relationshipID)?.status;

                    if (relationshipID == 6) {//Other
                        let mridex = localStorage.getItem(`mridex:${element.contactId}`);
                        explain = mridex;
                    }
                }


                let memObj = new FormGroup({
                    firstName: new FormControl(element.firstName),
                    lastName: new FormControl(element.lastName),
                    add1: new FormControl(element.add1),
                    city: new FormControl(element.city),
                    state: new FormControl(element.state),
                    zip: new FormControl(element.zip),
                    email: new FormControl(element.email),
                    mobile: new FormControl(element.mobile),
                    signupFee: new FormControl(this.changeToCurrency(element.signupFee)),
                    membershipFee: new FormControl(this.changeToCurrency(element.memberFee)),
                    memberFees: this.fb.array((memFee ?? []).map(fee => this.fb.group({
                        cMContractFeeID: new FormControl(fee?.cmContractFeeID),
                        cmProductFeeID: new FormControl(fee?.cmProductFeeID),
                        cmProductID: new FormControl(fee?.cmProductID),
                        cmMemberFeeID: new FormControl(fee?.cmMemberFeeID),
                        cMFeeName: new FormControl(fee?.cmFeeName),
                        feeTotal: new FormControl(this.changeToCurrency(fee.feeTotal)),
                        feeBase: new FormControl(this.changeToCurrency(fee.feeBase)),
                        feeTax: new FormControl(Math.round(this.changeToNumber(fee.feeTotal.toString()) * (this.site.taxRate / 100))),
                        isPrimary: new FormControl(element.cMIsPrimary),
                        isTaxable: new FormControl(fee?.isTaxable),
                        isRecurring: new FormControl(fee?.isRecurring),
                        isCCOverride: new FormControl(fee?.isCCOverride)
                    }))),
                    contactId: new FormControl(element.contactId),
                    statusId: new FormControl(element.statusId),
                    statusIdAdmin: new FormControl(element.statusIdAdmin),
                    cMMemberID: new FormControl(element.cMMemberID),
                    isF2FLinkCopied: new FormControl(false),
                    isExtraMem: new FormControl(member?.isExtraMem),
                    isPrimary: new FormControl(element.cMIsPrimary),
                    dtDL: new FormControl(element.dtDL),
                    relationship: new FormControl(relationship),
                    explain: new FormControl(explain)
                })

                if (member.isPrimary) {
                    this.primaryContactName = `${element.firstName} ${element.lastName}`;
                    this.titleService.setTitle(this.primaryContactName);
                }

                this.members.push(memObj);
            });
        }

        if (this.contractFees?.length > 0) {
            this.fees.controls = [];
            this.fees.removeAt(0);
            this.feeButtonList = [];

            if (!isChangePlan) {
                this.contractFees
                    .sort((a, b) => a.sOrder - b.sOrder)
                    .forEach((fee, index) => {
                        this.fees.push(
                            this.fb.group({
                                cMContractFeeID: fee.cMContractFeeID,
                                cmProductFeeID: fee.cMProductFeeID,
                                cmFeeName: fee.cMFeeName,
                                feeAmount: this.changeToCurrency(fee.feeBase),
                                //feeTax: this.changeToCurrency((fee.feeBase * this.site.taxRate) / 100) + ' (' + this.site.taxRate + '%)',
                                feeTax: this.changeToCurrency(fee.feeTax) + ' (' + this.site.taxRate + '%)',
                                isCollectNow: fee.isCollectNow,
                                isRequirePM: fee.isRequirePM,
                                isTaxable: fee.isTaxable,
                                isRecurring: fee.isRecurring,
                                recursEvery: fee.recursEvery,
                                recursEveryInterval: fee.recursEveryInterval,
                                isPaymentSplitable: fee.isPaymentSplitable,
                                isCCOverride: fee.isCCOverride,
                                memberSplitable: fee.memberSplitable,
                                sOrder: fee.sOrder
                            })
                        );

                        if (fee.memberSplitable == 2) {
                            this.feeButtonList.push({
                                cMContractFeeID: fee?.cMContractFeeID,
                                cMProductFeeID: fee.cMProductFeeID,
                                cMProductID: fee.cMProductID,
                                cMFeeName: fee.cMFeeName
                            });
                        }
                    });
            }
            else {
                if (this.product?.fees?.length > 0) {
                    this.product?.fees.sort((a, b) => a.sOrder - b.sOrder).forEach((fee, index) => {
                        this.fees.push(
                            this.fb.group({
                                cMContractFeeID: 0,
                                cmProductFeeID: fee.cmProductFeeID,
                                cmProductID: fee.cmProductID,
                                cmFeeName: fee.cmFeeName,
                                feeAmount: this.changeToCurrency(fee.feeAmount),
                                feeTax: this.changeToCurrency((fee.feeAmount * this.site.taxRate) / 100) + ' (' + this.site.taxRate + '%)',
                                isCollectNow: fee.isCollectNow,
                                isRequirePM: fee.isRequirePM,
                                isTaxable: fee.isTaxable,
                                isRecurring: fee.isRecurring,
                                recursEvery: fee.recursEvery,
                                recursEveryInterval: fee.recursEveryInterval,
                                isPaymentSplitable: fee.isPaymentSplitable,
                                isCCOverride: fee.isCCOverride,
                                memberSplitable: fee.memberSplitable,
                                sOrder: fee.sOrder
                            })
                        );

                        if (fee.memberSplitable == 2) {
                            this.feeButtonList.push({
                                cMContractFeeID: fee.cmProductFeeID,
                                cMProductFeeID: fee.cmProductFeeID,
                                cMProductID: fee.cmProductID,
                                cMFeeName: fee.cmFeeName
                            });
                        }
                    });
                }
            }
        }
        if (isRefresh)
            this.refreshMemAmount();

    }

    toSetPrimaryMemAtFirst<T>(array): T[] {
        const index = array.findIndex(obj => obj.contactId == this.fromContactId);
        if (index !== -1) {
            const objectToMove = array.splice(index, 1)[0];
            array.unshift(objectToMove);
        }
        return array;
    }

    async getMemberFee(_memberId: number) {
        await this._contractService.getMemberFee(this.encryptedUser, this.contractId, _memberId).
            then(async (result: CMMemberFeeListResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.memberFeeList = response.memberFees;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getContractFee", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    getMembershipFees(mem) {
        let controls = mem.controls['memberfees']?.controls.fees['controls'];
        return controls;
    }

    async patchContact(contact, isPrimary) {
        await this.contactForm.patchValue({
            txtFirstName: contact.firstName,
            txtLastName: contact.lastName,
            txtEmail: contact.email,
            txtMobilePhone: contact.mobile,
            txtHomePhone: contact.homePhone,
            txtZip: contact.zip,
            txtCity: contact.city,
            txtAddress: contact.add1,
            contactId: contact.contactId,
            country: this.setCountryDD(contact.country ? contact.country : 'US'),
            state: this.setStateDD(contact.state),
        });

        let mrid = localStorage.getItem(`mrid:${contact.contactId}`);

        let relationshipID: number = 2;
        let explain: string = '';

        if (mrid) {
            relationshipID = +mrid;
            let mridex = localStorage.getItem(`mridex:${contact.contactId}`);
            explain = mridex;
        }

        await this.contactForm2.patchValue({
            dl: contact.dl,
            emgContactName: contact.emergencyCName,
            txtEmgCntPhone: contact.emergencyCPhone,
            dob: contact.dob,
            site: contact.site,
            siteId: contact.siteID,
            relationshipID: contact.relationshipID > 0 ? contact.relationshipID : relationshipID,
            explain: contact.explain?.length > 0 ? contact.explain : explain,
            isPrimary: isPrimary
        });
    }

    setCountryDD(country) {
        if (this.countryDD?.length > 0) {
            let code = this.countryDD?.filter((item) => item?.country_Code?.toLowerCase() == country?.toLowerCase() || item?.country_Name?.toLowerCase() == country?.toLowerCase() || item?.country_Code2?.toLowerCase() == country?.toLowerCase())[0]?.country_Code;
            if (code) {
                return code;
            }
        }
        return "";
    }

    setStateDD(state) {
        if (this.stateList?.length > 0) {
            let code = this.stateList?.filter((item) => item?.value?.toLowerCase() == state?.toLowerCase() || item?.text?.toLowerCase() == state?.toLowerCase())[0]?.value;
            if (code) {
                return code;
            }
        }
        return "";
    }

    importPrimary() {
        if (this.contacts.length > 0) {
            this.contactForm.patchValue({
                txtHomePhone: this.contacts[0]?.homePhone,
                txtZip: this.contacts[0]?.zip,
                txtCity: this.contacts[0]?.city,
                txtAddress: this.contacts[0]?.add1,
                country: this.contacts[0]?.country,
                state: this.contacts[0]?.state
            });

            //this.countryCode = this.contacts[0]?.country;
            //this.stateCode = this.contacts[0]?.state;

            this.Log(`Imported Primary Member Info (${this.contacts[0]?.homePhone}, ${this.contacts[0]?.zip}, ${this.contacts[0]?.city}, ${this.contacts[0]?.add1}, ${this.contacts[0]?.country}, ${this.contacts[0]?.state}).`);
        }
    }

    //#endregion

    //#region site

    async getSiteData() {
        await this._clubService.Site_GetDD(this.encryptedUser, this.clpCompanyId, this.fromContactId).
            then(async (result: SiteDDListResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.siteList = response.sites;
                    this.setValidationOfSite();
                    this.clubId = response.clubId;

                    this.agentForm.patchValue({
                        agentName: response.agentName
                    });
                    this.getClubDetails();
                    if (this.classCode1) {
                        if (this.siteList.some(b => b.class1Code == this.classCode1) == true) {
                            this.site = this.siteList.filter(l => l.class1Code == this.classCode1)[0];
                            this.taxRate = this.site?.taxRate
                            this.setSite(this.site.siteID);

                            this.siteSelected = this.site.siteID

                            let filtered_s = this.siteList.filter(s => s.siteID == this.siteSelected);
                            if (filtered_s) {
                                this.siteSelectedName = filtered_s[0]?.siteName;
                            }
                        }
                    }
                    else {
                        this._notifyService.showError(`Please select a site in this contact's details.`, "", 10000);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getSiteData", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async siteChange(siteId) {
        this.site = this.siteList?.filter((item) => item?.siteID == siteId)[0];
        this.setSite(this.site.siteID);
        this.Log(`Site changed: ${this.siteSelectedName}.`);
    }

    async setSite(siteId) {
        this.siteId = siteId;
        this.siteSelected = this.siteId;

        let filtered_s = this.siteList.filter(s => s.siteID == this.siteSelected);
        if (filtered_s) {
            this.siteSelectedName = filtered_s[0]?.siteName;
        }

        await this.getProduct();
        await this.getContractDetailsById();
        this.getContractSetting();
        await this.cmSiteEmployees_GetContractAuditor();
        await this.cmSiteEmployees_GetSigningOfficers();
    }

    async cmSiteEmployees_GetContractAuditor() {
        if (this.siteId > 0) {
            await this._clubService.CMSiteEmployees_GetContractAuditor(this.encryptedUser, this.clpCompanyId, this.siteId, this.clubId).
                then(async (result: CMSiteEmployeesListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.contractAuditorList = response.listSiteEmployees;
                        let conAuditor = this.contractAuditorList.filter(s => s.userID == this.user?.cLPUserID && (s.siteID == this.siteId || s.siteID == 0))[0]
                        if (conAuditor == null && conAuditor == undefined) {
                            conAuditor = this.contractAuditorList.filter(s => s.userID == this.user?.cLPUserID)[0]
                        }
                        this.signOfficerEmpId = conAuditor?.iD;
                        if (conAuditor != null && conAuditor != undefined && this.contractStatusId == eREF_CMContractStatus.OnHold_Review) {
                            this.isShowReview = true;
                            this.isReview = false;
                        }
                        else {
                            this.isShowReview = false;
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("cm_contract.verifyContractAuditor", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }


    //#endregion

    //#region product

    async getProduct() {
        await this._productService.CMProduct_Get_All(this.encryptedUser, this.clpCompanyId, this.clubId, this.siteId)
            .then(async (result: ProductResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.all_productList = response?.products;

                    let filtered = this.all_productList.filter(p => p.isDefault && p.isActive);

                    if (filtered.length == 0) {
                        this._notifyService.showError("Please set your default product for this site in the Club Manager.", "", 10000);

                        filtered = this.all_productList.filter(p => p.isActive);

                        if (filtered.length == 0) {
                            this._notifyService.showError("Please add at least one Active product to this site and set it as the default product!", "", 10000);
                        }
                        else {
                            this.product = filtered[0];
                        }
                    }
                    else {
                        this.product = filtered[0];
                    }

                    this.intMaxMembers = this.product?.intMaxMembers;
                    this.setProduct(this.product, false);

                    this.productSelected = this.product?.class4Code;
                    this.upgradeSelected = this.product?.class4Code;

                    let p_filtered = this.all_productList.filter(p => p.class4Code == this.productSelected);
                    if (p_filtered) {
                        this.productSelectedName = p_filtered[0]?.productName;
                    }

                    this.productList = this.all_productList.filter(p => !p.isDeleted && p.isActive);
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    setProduct(product: Product, isUpgrade: boolean) {
        this.upgradeSelected = product?.class4Code;

        if (!isUpgrade) {
            this.productSelected = product?.class4Code;

            let p_filtered = this.all_productList.filter(p => p.class4Code == this.productSelected);
            if (p_filtered) {
                this.productSelectedName = p_filtered[0]?.productName;
            }
        }

        this.numPaymentsForm.patchValue({
            term: this.product?.contractTerm
        });

        this.termForm.patchValue({
            term: this.product?.contractTerm
        });

        this.siteTaxForm.patchValue({
            productDesc: this.product?.productDesc
        });

        this.isSeasonal = this.product?.isSeasonal;
        this.isDays = this.product?.isDays;
        let daysOfWeek = this.product?.daysOfWeekOnPlan.split(',');
        this.isEveryday = !daysOfWeek?.some(item => item.toLowerCase() == 'false');


        let beginDate = this.siteTaxForm.controls["paymentBegin"].value;
        let endContract = this.addMonthsContract(beginDate, +this.product?.contractTerm);
        let endPayment = this.addMonthsPayments(beginDate, +this.product?.contractTerm);

        if (this.isDays) {
            this.siteTaxForm.patchValue({
                isMonday: this.product?.isMonday,
                isTuesday: this.product?.isTuesday,
                isWednesday: this.product?.isWednesday,
                isThursday: this.product?.isThursday,
                isFriday: this.product?.isFriday,
                isSaturday: this.product?.isSaturday,
                isSunday: this.product?.isSunday,
                contractEnd: endContract,
                contractEndLabel: this.getFormattedDate(endContract),
                paymentEnd: endPayment,
                paymentEndLabel: this.getFormattedDate(endPayment)
            });
        }
        else {
            this.siteTaxForm.patchValue({
                isMonday: this.product?.isMonday,
                isTuesday: this.product?.isTuesday,
                isWednesday: this.product?.isWednesday,
                isThursday: this.product?.isThursday,
                isFriday: this.product?.isFriday,
                isSaturday: this.product?.isSaturday,
                isSunday: this.product?.isSunday,
                contractEnd: endContract,
                contractEndLabel: this.getFormattedDate(endContract),
                paymentEnd: endPayment,
                paymentEndLabel: this.getFormattedDate(endPayment)
            });

            this.siteTaxForm.get('isMonday')?.disable();
            this.siteTaxForm.get('isTuesday')?.disable();
            this.siteTaxForm.get('isWednesday')?.disable();
            this.siteTaxForm.get('isThursday')?.disable();
            this.siteTaxForm.get('isFriday')?.disable();
            this.siteTaxForm.get('isSaturday')?.disable();
            this.siteTaxForm.get('isSunday')?.disable();
        }

        this.addTimeout(() => {
            // Patch Sites
            if (this.product?.locationAccess) {
                const siteIDs = this.product?.locationAccess.split(",");

                this.siteList.forEach(site => {
                    this.siteTaxForm.get(`s${site.siteID}`)?.setValue(false);
                });

                siteIDs.forEach(id => {
                    if (this.siteTaxForm.get(`s${id}`))
                        this.siteTaxForm.get(`s${id}`)?.setValue(true);
                });
            }
            else {
                this.siteList.forEach(site => {
                    this.siteTaxForm.get(`s${site.siteID}`)?.setValue(true);
                });
            }

            // Patch Classes
            if (this.product?.boatClasses) {
                const classIDs = this.product?.boatClasses.split(",");
                this.cmBoatClasses.forEach(cls => {
                    this.siteTaxForm.get(`b${cls.classID}`)?.setValue(false);
                });

                classIDs.forEach(id => {
                    if (this.siteTaxForm.get(`b${id}`))
                        this.siteTaxForm.get(`b${id}`)?.setValue(true);
                });
            }
            else {
                if (this.product?.locationAccess) {
                    this.cmBoatClasses.forEach(cls => {
                        this.siteTaxForm.get(`b${cls.classID}`)?.setValue(false);
                    });
                }
                else {
                    this.cmBoatClasses.forEach(cls => {
                        this.siteTaxForm.get(`b${cls.classID}`)?.setValue(true);
                    });
                }
            }
        }, 200)

        this.fees.controls = [];
        this.fees.removeAt(0);
        this.feeButtonList = [];

        if (this.product?.fees?.length > 0) {
            this.product?.fees.sort((a, b) => a.sOrder - b.sOrder).forEach((fee, index) => {
                this.fees.push(
                    this.fb.group({
                        cMContractFeeID: 0,
                        cmProductFeeID: fee.cmProductFeeID,
                        cmProductID: fee.cmProductID,
                        cmFeeName: fee.cmFeeName,
                        feeAmount: this.changeToCurrency(fee.feeAmount),
                        feeTax: this.changeToCurrency((fee.feeAmount * this.site.taxRate) / 100) + ' (' + this.site.taxRate + '%)',
                        isCollectNow: fee.isCollectNow,
                        isRequirePM: fee.isRequirePM,
                        isTaxable: fee.isTaxable,
                        isRecurring: fee.isRecurring,
                        recursEvery: fee.recursEvery,
                        recursEveryInterval: fee.recursEveryInterval,
                        isPaymentSplitable: fee.isPaymentSplitable,
                        isCCOverride: fee.isCCOverride,
                        memberSplitable: fee.memberSplitable,
                        sOrder: fee.sOrder
                    })
                );

                if (fee.memberSplitable == 2) {
                    this.feeButtonList.push({
                        cMContractFeeID: fee.cmProductFeeID,
                        cMProductFeeID: fee.cmProductFeeID,
                        cMProductID: fee.cmProductID,
                        cMFeeName: fee.cmFeeName
                    });
                }
            });
        }

        if (!isUpgrade) {
            if (this.contractId > 0 && this.productSelected != this.contracts[0]?.class4Code) {
                //placeholder to make clear to get fees for plan change and not for existing plan; for CHANGE PLAN
                this.buildContactList(false, true);
            }
            else if (this.contractId > 0 && this.productSelected == this.contracts[0]?.class4Code) {
                this.buildContactList(false, false);
            }
            else {
                this.buildContactList(false, false);
            }
        }
        else {
            if (this.contractId > 0 && this.upgradeSelected == this.contracts[0]?.class4Code) {
                this.siteTaxForm.patchValue({
                    specialterms: this.contracts[0]?.specialTerms,
                    productDesc: this.contracts[0]?.productDesc,
                    reservationID: this.contracts[0]?.reservationID,
                    contractStart: new Date(this.contracts[0]?.dtContractStart),
                    contractStartLabel: this.getFormattedDate(new Date(this.contracts[0]?.dtContractStart)),
                    paymentBegin: new Date(this.contracts[0]?.dtPaymentBegins),
                    paymentBeginLabel: this.getFormattedDate(new Date(this.contracts[0]?.dtPaymentBegins)),
                    contractExpires: new Date(this.contracts[0]?.dtExpires),
                    contractExpiresLabel: this.getFormattedDate(new Date(this.contracts[0]?.dtExpires)),
                    contractEnd: new Date(this.contracts[0]?.dtContractEnd),
                    contractEndLabel: this.getFormattedDate(new Date(this.contracts[0]?.dtContractEnd)),
                    contractSigned: this.getFormattedDate(new Date(this.contracts[0]?.dtExpires))
                });

                let numberOfPayments = this.contracts[0]?.contractTerm;
                let contractTerm = this.contracts[0]?.contractTerm2;

                let contractTermReadOnly = this.monthDiff(this.contracts[0]?.dtContractStart, this.contracts[0]?.dtContractEnd);
                let contractTermValue = contractTerm ? contractTerm : contractTermReadOnly;

                let finalPayment = this.addMonthsPayments(this.contracts[0]?.dtPaymentBegins, contractTermValue);

                this.numPaymentsForm.patchValue({
                    term: numberOfPayments
                });

                this.siteTaxForm.patchValue({
                    paymentEnd: finalPayment,
                    paymentEndLabel: this.getFormattedDate(finalPayment)
                });

                this.termForm.patchValue({
                    term: contractTermValue
                });

                if (this.contractFees?.length > 0) {
                    this.fees.controls = [];
                    this.fees.removeAt(0);
                    this.feeButtonList = [];

                    this.contractFees
                        .sort((a, b) => a.sOrder - b.sOrder)
                        .forEach((fee, index) => {
                            this.fees.push(
                                this.fb.group({
                                    cMContractFeeID: fee.cMContractFeeID,
                                    cmProductFeeID: fee.cMProductFeeID,
                                    cmFeeName: fee.cMFeeName,
                                    feeAmount: this.changeToCurrency(fee.feeBase),
                                    //feeTax: this.changeToCurrency((fee.feeBase * this.site.taxRate) / 100) + ' (' + this.site.taxRate + '%)',
                                    feeTax: this.changeToCurrency(fee.feeTax) + ' (' + this.site.taxRate + '%)',
                                    isCollectNow: fee.isCollectNow,
                                    isRequirePM: fee.isRequirePM,
                                    isTaxable: fee.isTaxable,
                                    isRecurring: fee.isRecurring,
                                    recursEvery: fee.recursEvery,
                                    recursEveryInterval: fee.recursEveryInterval,
                                    isPaymentSplitable: fee.isPaymentSplitable,
                                    isCCOverride: fee.isCCOverride,
                                    memberSplitable: fee.memberSplitable,
                                    sOrder: fee.sOrder
                                })
                            );

                            if (fee.memberSplitable == 2) {
                                this.feeButtonList.push({
                                    cMContractFeeID: fee?.cMContractFeeID,
                                    cMProductFeeID: fee.cMProductFeeID,
                                    cMProductID: fee.cMProductID,
                                    cMFeeName: fee.cMFeeName
                                });
                            }
                        });
                }
            }
        }
    }

    contractStartChange(event: MatDatepickerInputEvent<Date>) {
        let paymentBegin = this.siteTaxForm.controls['paymentBegin'].value;
        if (this.inputIsBeforeDate(paymentBegin, event.value)) {

            this.siteTaxForm.patchValue({
                paymentBegin: event.value,
                paymentBeginLabel: this.getFormattedDate(event.value)
            });
        }
        let expires = this.addDays(event.value, 7);

        this.siteTaxForm.patchValue({
            contractExpires: expires,
            contractExpiresLabel: this.getFormattedDate(expires)
        });

        let numberPayments = +this.numPaymentsForm.controls["term"].value;
        let endPayments = this.addMonthsContract(event.value, numberPayments);

        //update Contract Term (Months)
        let c_start = this.getFormattedDate(event.value);
        let c_end = this.getFormattedDate(endPayments);

        let contractTermReadOnly = this.monthDiff(c_end, c_start);

        this.termForm.patchValue({
            term: contractTermReadOnly
        });


        this.siteTaxForm.patchValue({
            contractEnd: endPayments,
            contractEndLabel: this.getFormattedDate(endPayments)
        });
    }

    contractBeginsChange(event: MatDatepickerInputEvent<Date>) {
        let start = this.siteTaxForm.controls['contractStart'].value;
        if (this.inputIsBeforeDate(event.value, start)) {

            this.siteTaxForm.patchValue({
                paymentBegin: start,
                paymentBeginLabel: this.getFormattedDate(start)
            });
            this._notifyService.showError('Payment Begins cannot be before Contract Start. Payment Begins has been adjusted.', '', 5000);
        }

        let numberOfPayments = +this.numPaymentsForm.controls["term"].value;
        let end = this.addMonthsContract(event.value, numberOfPayments);
        let endPayments = this.addMonthsPayments(event.value, numberOfPayments);

        //update Contract Term (Months)
        let c_end = this.getFormattedDate(end);

        let contractTermReadOnly = this.monthDiff(c_end, this.getFormattedDate(start));

        this.termForm.patchValue({
            term: contractTermReadOnly
        });


        this.siteTaxForm.patchValue({
            contractEnd: end,
            contractEndLabel: this.getFormattedDate(end),
            paymentEnd: endPayments,
            paymentEndLabel: this.getFormattedDate(endPayments)
        });
    }

    contractEndChange(event: MatDatepickerInputEvent<Date>) {
        let start = this.siteTaxForm.controls['contractStart'].value;
        let event_end = event.value;
        if (this.inputIsBeforeDate(event_end, start)) {
            let add = this.addMonths(start, 1);
            this.siteTaxForm.patchValue({
                contractEnd: add,
                contractEndLabel: this.getFormattedDate(add)
            });
            this._notifyService.showError('Contract Start must be before Contract End. Contract End has been adjusted.', '', 5000);

            event_end = add;
        }

        let finalPayment = this.siteTaxForm.controls['paymentEnd'].value;

        if (this.inputIsBeforeDate(event_end, finalPayment)) {
            this.siteTaxForm.patchValue({
                contractEnd: finalPayment,
                contractEndLabel: this.getFormattedDate(finalPayment)
            });
            this._notifyService.showError('Contract End must be later than Final Payment. Contract End has been adjusted.', '', 5000);

            event_end = finalPayment;
        }

        //update Contract Term (Months)
        let c_end = this.getFormattedDate(event_end);

        let contractTermReadOnly = this.monthDiff(this.getFormattedDate(start), c_end);

        this.termForm.patchValue({
            term: contractTermReadOnly
        });
    }

    contractStartSelectToday(picker: MatDatepicker<Date>) {
        const today = new Date();

        this.siteTaxForm.patchValue({
            contractStart: today,
            contractStartLabel: this.getFormattedDate(today)
        });

        let expires = this.addDays(today, 7);

        this.siteTaxForm.patchValue({
            contractExpires: expires,
            contractExpiresLabel: this.getFormattedDate(expires)
        });

        let numberPayments = +this.numPaymentsForm.controls["term"].value;
        let endPayments = this.addMonthsContract(today, numberPayments);

        //update Contract Term (Months)
        let c_start = this.getFormattedDate(today);
        let c_end = this.getFormattedDate(endPayments);

        let contractTermReadOnly = this.monthDiff(c_end, c_start);

        this.termForm.patchValue({
            term: contractTermReadOnly
        });


        this.siteTaxForm.patchValue({
            contractEnd: endPayments,
            contractEndLabel: this.getFormattedDate(endPayments)
        });

        picker.select(today);
        picker.close();
    }

    paymentBeginsSelectToday(picker: MatDatepicker<Date>) {
        let start = this.siteTaxForm.controls['contractStart'].value;
        const today = new Date();

        if (this.inputIsBeforeDate(today, start)) {

            this.siteTaxForm.patchValue({
                paymentBegin: start,
                paymentBeginLabel: this.getFormattedDate(start)
            });
            this._notifyService.showError('Payment Begins cannot be before Contract Start. Payment Begins has been adjusted.', '', 5000);
        }


        this.siteTaxForm.patchValue({
            paymentBegin: today,
            paymentBeginLabel: this.getFormattedDate(today)
        });

        let term = +this.numPaymentsForm.controls["term"].value;
        let endPayments = this.addMonthsContract(today, term);

        //update Contract Term (Months)
        let c_end = this.getFormattedDate(endPayments);

        let contractTermReadOnly = this.monthDiff(c_end, start);

        this.termForm.patchValue({
            term: contractTermReadOnly
        });


        this.siteTaxForm.patchValue({
            contractEnd: endPayments,
            contractEndLabel: this.getFormattedDate(endPayments),
            paymentEnd: endPayments,
            paymentEndLabel: this.getFormattedDate(endPayments)
        });

        picker.select(today);
        picker.close();
    }

    contractEndsSelectToday(picker: MatDatepicker<Date>) {
        let start = this.siteTaxForm.controls['contractStart'].value;
        let today = new Date();

        if (this.inputIsBeforeDate(today, start)) {
            let add = this.addMonths(start, 1);
            this.siteTaxForm.patchValue({
                contractEnd: add,
                contractEndLabel: this.getFormattedDate(add)
            });
            this._notifyService.showError('Contract Start must be before Contract End. Contract End has been adjusted.', '', 5000);

            today = add;
        }

        let finalPayment = this.siteTaxForm.controls['paymentEnd'].value;

        if (this.inputIsBeforeDate(today, finalPayment)) {
            this.siteTaxForm.patchValue({
                contractEnd: finalPayment,
                contractEndLabel: this.getFormattedDate(finalPayment)
            });
            this._notifyService.showError('Contract End must be later than Final Payment. Contract End has been adjusted.', '', 5000);

            today = finalPayment;
        }

        //update Contract Term (Months)
        let c_end = this.getFormattedDate(today);

        let contractTermReadOnly = this.monthDiff(this.getFormattedDate(start), c_end);

        this.termForm.patchValue({
            term: contractTermReadOnly
        });

        this.siteTaxForm.patchValue({
            contractEnd: today,
            contractEndLabel: this.getFormattedDate(today)
        });

        picker.select(today);
        picker.close();
    }

    contractExpiresSelectToday(picker: MatDatepicker<Date>) {
        const today = new Date();

        picker.select(today);
        picker.close();
    }

    paymentEndSelectToday(picker: MatDatepicker<Date>) {
        const today = new Date();

        picker.select(today);
        picker.close();
    }

    changeTermC() {
        let beginDate = this.siteTaxForm.controls["paymentBegin"].value;
        let endPayments = this.addMonthsContract(beginDate, +this.numPaymentsForm.controls["term"].value);
        let endPaymentTerm = this.addMonthsPayments(beginDate, +this.numPaymentsForm.controls["term"].value);

        this.Log(`Term (Months) changed to ${this.numPaymentsForm.controls["term"].value}.`);

        this.siteTaxForm.patchValue({
            contractEnd: endPayments,
            contractEndLabel: this.getFormattedDate(endPayments),
            paymentEnd: endPaymentTerm,
            paymentEndLabel: this.getFormattedDate(endPaymentTerm)
        });

        //update Contract Term (Months)
        let start = this.siteTaxForm.controls['contractStart'].value;
        let end = this.siteTaxForm.controls['contractEnd'].value;

        let contractTermReadOnly = this.monthDiff(end, start);

        this.termForm.patchValue({
            term: contractTermReadOnly
        });
    }

    changeTermP() {
        let beginDate = this.siteTaxForm.controls["paymentBegin"].value;
        let end = this.addMonthsPayments(beginDate, +this.termForm.controls["term"].value);

        this.Log(`Number of Payments changed to ${this.termForm.controls["term"].value}.`);

        this.siteTaxForm.patchValue({
            paymentEnd: end,
            paymentEndLabel: this.getFormattedDate(end)
        });
    }

    getProductDescription() {
        return this.siteTaxForm.controls['productDesc'].value;
    }

    productChange(class4Code, isUpgrade: boolean, isUI: boolean) {
        this.product = this.all_productList.filter(p => p.class4Code == class4Code)[0];
        this.intMaxMembers = this.product?.intMaxMembers;
        this.setProduct(this.product, isUpgrade);

        if (isUI)
            this.Log(`Product changed: ${this.productSelectedName}.`);
    }
    //#endregion

    //#region CMContract details

    async getContractSetting() {
        await this._contractService.cmSiteContractSetting_Get(this.encryptedUser, this.siteId).
            then(async (result: CMContractSettingResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.ContractSetting = response.setting;
                    this.patchConfigForm();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getContractSetting", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    patchConfigForm() {
        this.paymentForm.patchValue({
            isEntryCC: this.ContractSetting?.isEntryCC,
            isEntryACH: this.ContractSetting?.isEntryACH,
            isEntryCheck: this.ContractSetting?.isEntryCheck,
            isEntryCash: this.ContractSetting?.isEntryCash,
            isMonthlyCC: this.ContractSetting?.isMonthlyCC,
            isMonthlyACH: this.ContractSetting?.isMonthlyACH,
            isMonthlyCheck: this.ContractSetting?.isMonthlyCheck,
        });
    }

    async getContractDetails(_contractId) {
        await this._contractService.cmContractGet(this.encryptedUser, this.clpCompanyId, 0, this.siteId, this.contractId).
            then(async (result: ContractResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.contracts = [];
                    this.contracts = UtilityService.clone(response.contracts);
                    if (this.contracts && this.contracts.length > 0) {
                        this.totalSignupFee = 0;
                        this.totalMemberFee = 0;
                        await this.patchContractData();
                        this.cmContractType_GetList();
                        this.actionTypes_GetList();
                        this.intMaxMembers = this.contracts[0]?.intMaxMembers;
                        this.is_transfer = this.contracts[0]?.isTransfer;

                        if (this.contracts[0].statusID == eREF_CMContractStatus.Waiting_CounterSign && this.contracts[0]?.members.filter(s => s.statusID == eREF_CMMemberStatus.Active).length == this.intMaxMembers) {
                            this.disableSaveContract = true
                        }
                        this.cmSiteEmployees_GetContractAuditor();
                        this.cmSiteEmployees_GetSigningOfficers();
                        if (this.contracts[0]?.members) {
                            this.contacts = [];
                            this.contracts[0]?.members.forEach((item) => {
                                if (!item.isPrimary) {
                                    localStorage.setItem(`mrid:${item.contactID}`, item.relationshipID.toString());
                                    localStorage.setItem(`mridex:${item.contactID}`, item.explain);
                                }

                                this.contactId = item.contactID;
                                this.totalSignupFee += item.feeSignUp;
                                this.totalMemberFee += item.feeMembership;
                                this.getContactData(false, () => {
                                    let dtSigned = this.contracts[0]?.dtSignedMembers != '0001-01-01T00:00:00' ? this.getFormattedDate(new Date(this.contracts[0]?.dtSignedMembers)) : '';
                                    const firstCollectNowFee = this.fees.value.find((fee: any) => fee.isCollectNow);

                                    this.addPMDtSigned = dtSigned;
                                    this.renewDtSigned = dtSigned;

                                    this.upgradeForm.patchValue({
                                        alreadyPaid: firstCollectNowFee.feeAmount,
                                        alreadyPaidTax: firstCollectNowFee.feeTax,
                                        alreadyPaidIsTaxable: firstCollectNowFee.isTaxable,
                                        dtAlreadyPaid: dtSigned,
                                        upgradeSelected: this.upgradeSelected
                                    });
                                });
                            });
                        }
                    }
                    else {
                        if (this.contractId > 0) {
                            this._notifyService.showError(`Contract detected (${this.contractId}), but SiteID (${this.siteId}) doesn't match contact.`, "Site Mismatch", 10000)
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getContractDetails", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getContractDetailsById() {
        await this._contractService.cmContractGetById(this.encryptedUser, this.user?.cLPUserID, this.fromContactId).
            then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response.messageInt > 0) {
                        this.contractId = response.messageInt;
                        this.cMContractFee_Get(this.contractId, () => {

                            this.getContractDetails(this.contractId);
                            this.contractEdit = false;
                        });
                        this.checkContractPayment();
                    }
                    else {
                        this.contractId = 0;
                        this.contractEdit = true;

                        //Brand-new (not-yet-saved) contract: it defaults to type New, so look up
                        //the contact's ResNet account status now so it can be persisted on Save.
                        if (this.contractTypeID == 1) {
                            this.getResNetAccountStatusOnOpen();
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getContractDetails", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getContractDeletedById() {
        await this._contractService.cmContractGetById(this.encryptedUser, this.user?.cLPUserID, this.fromContactId).
            then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response.messageInt > 0) {
                        this.contractId = response.messageInt;
                        this.cMContractFee_Get(this.contractId, () => {
                            this.getContractDetails(this.contractId);
                            //this.contractEdit = false;
                        });
                        this.checkContractPayment();
                    }
                    else {
                        this.contractId = 0;
                        this.contractEdit = true;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getContractDeletedById", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    calculateSignUpFee($event) {
        this.totalSignupFee = +$event;
        this.contacts.forEach((item) => {
            if (item.contactId == this.contactId)
                item.signupFee = +$event
        });
    }

    calculateMemberFee($event) {
        this.totalMemberFee = +$event;
        this.contacts.forEach((item) => {
            if (item.contactId == this.contactId)
                item.memberFee = +$event
        });
    }

    applyNewProduct() {
        this.saveContract(null);
    }

    async saveContract(callback, isUnEvenPayConfirm: boolean = false) {

        if (this.actionTypeID == 0) {
            Swal.fire({ icon: "warning", title: "", html: 'Please select an Action.' });
            return;
        }

        // ── Member contact-info warning ─────────────────────────────────────────
        // The "Send Contract" and "Face to Face" buttons require the member to have
        // both an email and a mobile phone number. We don't block the save itself
        // (the user may want to save other progress first), but we surface the issue
        // here so they can choose to fix it before continuing — and so we never get
        // a saved-and-ready contract that can't actually be sent.
        if (!this.contactInfoWarningAcknowledged) {
            const issues = this.getMembersMissingContactInfo();
            if (issues.length > 0) {
                const issuesHtml = issues.map(i => `<li style="text-align:left">${i}</li>`).join('');
                Swal.fire({
                    title: 'Member Contact Info Missing',
                    html:
                        'The following member(s) are missing contact information needed to send the contract:' +
                        `<ul style="margin-top:10px">${issuesHtml}</ul>` +
                        'You can save the contract now, but <strong>"Send Contract"</strong> and ' +
                        '<strong>"Face to Face"</strong> will stay disabled for these members until ' +
                        'an email <em>and</em> mobile phone are added to their contact record.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Save Anyway',
                    cancelButtonText: 'Cancel',
                    confirmButtonColor: '#3085d6',
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.contactInfoWarningAcknowledged = true;
                        this.saveContract(callback, isUnEvenPayConfirm);
                    }
                });
                return;
            }
        }

        // Only intercept if the user actually changed something. Angular marks a
        // FormGroup dirty as soon as any control value is modified by the user;
        // programmatic patchValue/setValue calls leave the form pristine.
        const hasChanges =
            (this.siteTaxForm?.dirty ?? false) ||      // fees, special terms, dates, location access
            (this.agentForm?.dirty ?? false) ||         // agent assignment
            (this.paymentForm?.dirty ?? false) ||       // payment method (CC/ACH/etc.)
            (this.termForm?.dirty ?? false) ||          // contract term
            (this.numPaymentsForm?.dirty ?? false);     // number of payments (months)

        // ── End member contact-info warning ─────────────────────────────────────
        // (contactInfoWarningAcknowledged is reset together with resetSignaturesConfirmed
        //  below, so a second guard later in this function — e.g. the signature-reset
        //  warning — doesn't accidentally trip the contact-info dialog a second time.)

        // ── Signature-invalidation guard ────────────────────────────────────────
        // If any member has already signed (statusID >= eSigned = 5) and the admin
        // hasn't yet confirmed they want to proceed, show a warning and – after
        // confirmation – wipe all signatures, document acceptances, and wizard
        // navigation state so the member must restart the contract process.
        if (!this.resetSignaturesConfirmed && this.contractId > 0) {
            // Window: contract is Members_Signed (3) only — NOT OnHold_Review (4) or beyond.
            // Member window: eSigned (5) only — NOT Payment_Complete (6) or beyond.
            // Once "Charge" has been clicked (member reaches Payment_Complete), we must NOT
            // wipe signatures or payment records.
            const contractInSignedWindow =
                this.contractStatusId >= eREF_CMContractStatus.Members_Signed &&
                this.contractStatusId < eREF_CMContractStatus.OnHold_Review;   // i.e. === 3

            const memberInSignedWindow = this.contract?.members?.some(m =>
                (m.statusID >= eREF_CMMemberStatus.eSigned &&
                 m.statusID < eREF_CMMemberStatus.Payment_Complete) ||          // i.e. === 5
                (m.eSigFullImage &&
                 m.eSigFullImage.toString().trim().length > 0 &&
                 m.statusID < eREF_CMMemberStatus.Payment_Complete)
            ) ?? false;

            const hasSigned = contractInSignedWindow || memberInSignedWindow;

            if (hasSigned && hasChanges) {
                Swal.fire({
                    title: 'Contract Has Been Signed',
                    html: 'One or more members have already signed this contract.<br><br>' +
                          'Saving these changes will <strong>invalidate all signatures and ' +
                          'document acceptances</strong>. No payments have been collected. ' +
                          'The member(s) will need to restart the contract process from the beginning.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, save and reset signatures',
                    cancelButtonText: 'Cancel',
                    confirmButtonColor: '#d33',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.showSpinner = true;
                        try {
                            const resetRes = await this._contractService.cmContract_ResetSignatures(
                                this.encryptedUser,
                                this.contractId,
                                this.user?.cLPCompanyID ?? 0,
                                this.user?.cLPUserID ?? 0,
                                this.user?.cLPUserID ?? 0
                            );
                            if (resetRes) {
                                this._notifyService.showSuccess(
                                    'Signatures and payment setup have been cleared. Please save the contract.',
                                    'Signatures Cleared', 5000
                                );

                                // ── Sync in-memory state with what the DB now contains ──
                                // Three separate stores all feed into CMContract_Update:
                                //   1. this.contractStatusId / this.contractStatusIdAdmin
                                //      → read by prepareContractForm() lines 2730-2731
                                //   2. this.contract.members / this.contracts[0].members (data arrays)
                                //      → read by various status checks after CMContract_Update
                                //   3. this.members FormArray (membersForm)
                                //      → read by prepareContractForm() line 2818 to build
                                //        this.contract.members before calling CMContract_Update
                                // All three must be synced or CMContract_Update will write 5 back.
                                this.contractStatusId = eREF_CMContractStatus.In_Progress;
                                this.contractStatusIdAdmin = eREF_CMContractStatus.In_Progress;

                                // 1 & 2: sync the data arrays
                                const syncMemberArray = (members: CMContractMember[]) => {
                                    if (!members) return;
                                    members.forEach(m => {
                                        if (m.statusID >= eREF_CMMemberStatus.eSigned &&
                                            m.statusID < eREF_CMMemberStatus.Payment_Complete) {
                                            m.statusID       = eREF_CMMemberStatus.Ready_To_Send;
                                            m.statusIDAdmin  = eREF_CMMemberStatus.Ready_To_Send;
                                        }
                                        m.eSigFullImage     = null;
                                        m.eSigInitialsImage = null;
                                        m.eInitials         = null;
                                        // eFullName, eSigLength, eSigInitLength are not on the
                                        // TS interface — the stored proc clears them in the DB.
                                    });
                                };
                                syncMemberArray(this.contract?.members);
                                syncMemberArray(this.contracts?.[0]?.members);

                                // 3: sync the membersForm FormArray — this is what
                                //    prepareContractForm() actually reads to build
                                //    this.contract.members before CMContract_Update fires.
                                const memberControls = (this.membersForm?.get('members') as FormArray)?.controls;
                                if (memberControls) {
                                    memberControls.forEach(ctrl => {
                                        const s = ctrl.get('statusId')?.value;
                                        if (s >= eREF_CMMemberStatus.eSigned &&
                                            s < eREF_CMMemberStatus.Payment_Complete) {
                                            ctrl.patchValue({
                                                statusId:      eREF_CMMemberStatus.Ready_To_Send,
                                                statusIdAdmin: eREF_CMMemberStatus.Ready_To_Send
                                            }, { emitEvent: false });
                                        }
                                    });
                                }
                                // ── End in-memory sync ──

                                this.resetSignaturesConfirmed = true;
                                this.saveContract(callback, isUnEvenPayConfirm);
                            } else {
                                this._notifyService.showError(
                                    'Failed to clear signatures. Please try again.',
                                    'Error', 5000
                                );
                            }
                        } catch (err) {
                            console.error('CMContract_ResetSignatures error', err);
                            this._notifyService.showError(
                                'An error occurred while clearing signatures.',
                                'Error', 5000
                            );
                        } finally {
                            this.showSpinner = false;
                        }
                    }
                });
                return;
            }
        }
        // Reset flags so future saves re-check (flags are only one-shot pass-throughs)
        this.resetSignaturesConfirmed = false;
        this.contactInfoWarningAcknowledged = false;
        // ── End signature-invalidation guard ────────────────────────────────────

        if (this.actionTypeID != 2 && this.actionTypeID != 3 && this.actionTypeID != 4) {//IF NOT UPGRADE -> these will be different on upgrades, but that's ok
            if (this.contractId > 0) {
                if (this.fees?.length > 0) {
                    for (const fee of this.fees.value) {
                        const valid = this.feeChange(fee);
                        if (!valid) {
                            return;
                        }
                    }
                }
            }
            else {
                if (this.product?.fees?.length > 0) {
                    for (const fee of this.product.fees) {
                        const valid = this.feeChange(fee);
                        if (!valid) {
                            return;
                        }
                    }
                }
            }
        }

        if (this.contractId > 0 && this.productSelected != this.contracts[0]?.class4Code && !this.changeContractPlan && this.actionTypeID != 2 && this.actionTypeID != 3 && this.actionTypeID != 4 && this.actionTypeID != 9) {
            $('#changePlanConfirmation').modal('show');
            return;
        }

        if (!this.upgradeConfirmed && this.actionTypeID == 3) {//IF UPGRADE
            this.upgradeSelected = this.upgradeForm.controls['upgradeSelected'].value;
            if (this.productSelected != this.upgradeSelected) {
                $('#upgradeContractConfirmation').modal('show');
                return;
            }
            else {
                this._notifyService.showError('Please select a new product to change this contract.', "Change", 10000)
                return;
            }
        }

        if (!this.changeConfirmed && this.actionTypeID == 5 && hasChanges) {//IF CHANGE
            $('#changeContractConfirmation').modal('show');
            return;
        }
        else {
            if (this.actionTypeID == 5 && !hasChanges) {
                this.actionTypeID = 0;
            }
        }

        if (!this.renewConfirmed && this.contractId > 0 && this.actionTypeID == 2) { //IF RENEWING
            this.upgradeSelected = this.upgradeForm.controls['upgradeSelected'].value;
            if (this.productSelected != this.upgradeSelected) {
                $('#renewContractConfirmation').modal('show');
                return;
            }
            else {
                if (this.resnet_renew) {
                    this._notifyService.showError('Please select a new product to renew this contract.', "Renew", 10000)
                    return;
                }
                else {
                    $('#renewContractConfirmation').modal('show');
                    return;
                }
            }
        }

        if (!this.addPMConfirmed && this.contractId > 0 && this.actionTypeID == 4) { //IF ADD PAYING MEMBER
            if (this.productSelected != this.upgradeSelected) {
                $('#addPMContractConfirmation').modal('show');
                return;
            }
            else {
                if (this.resnet_addpaying) {
                    this._notifyService.showError(`Please select a new product to add a ${this.paying}member.`, `Add ${this.paying}member.`, 10000)
                    return;
                }
                else {
                    $('#addPMContractConfirmation').modal('show');
                    return;
                }
            }
        }

        if (!this.terminateConfirmed && this.contractId > 0 && this.actionTypeID == 9) { //IF TERMINATE
            $('#terminatePlanConfirmation').modal('show');
            return;
        }

        let invalidDates = ''
        if (this.siteTaxForm.controls['contractStart'].value == null || this.siteTaxForm.controls['contractStart'].value == undefined) {
            invalidDates = "Contract Start, "
        }

        if (this.siteTaxForm.controls['paymentBegin'].value == null || this.siteTaxForm.controls['paymentBegin'].value == undefined) {
            invalidDates = invalidDates + "Payment Begin, "
        }

        if (this.siteTaxForm.controls['contractExpires'].value == null || this.siteTaxForm.controls['contractExpires'].value == undefined) {
            invalidDates = invalidDates + "Contract Expire "
        }

        if (invalidDates?.length > 0) {
            this._notifyService.showError(invalidDates + "dates are invalid", "", 10000)
            return
        }

        this.prepareContractForm();

        let isPayByEveryMem = true;
        let feeName = "";
        let fees = '';
        let members = '';

        this.contract.fees.forEach((fee) => {
            fees += ` ${fee.cMFeeName} $${fee.feeBase},`;
        });

        fees = fees.substring(0, fees.length - 1);

        this.members.value.forEach(row => {
            let contractMemberFees = this.contract.memberfees.filter(m => m.contactID == row.contactId);

            //get all the fees here and add it to the member
            let firstName = row.firstName;
            let lastName = row.lastName;
            let contactId = row.contactId;
            let m_fees = '';

            contractMemberFees?.forEach(f => {
                m_fees += ` ${f.cmFeeName} ${this.changeToCurrency(f.feeBase)},`;
            });

            m_fees = m_fees.substring(0, m_fees.length - 1);

            members += `${firstName} ${lastName} (${contactId}): ${m_fees}, `;
        });
        let productTotal = 0, memTotalFee = 0

        members = members.substring(0, members.length - 1);

        if (this.contractId > 0) {
            if (this.fees?.length > 0) {
                this.fees.value.forEach((fee) => {
                    if (fee?.memberSplitable == 3) {
                        this.contract.memberfees.forEach((mem) => {
                            let isExtraMem = this.contract.members.find((item) => item?.cMMemberID == mem?.memberID).isExtraMem;
                            if (fee?.cmProductFeeID == mem?.cmProductFeeID && fee?.feeAmount > 0 && !isExtraMem) {
                                if (mem?.feeBase == 0) {
                                    isPayByEveryMem = false;
                                    feeName = `${mem?.cmFeeName}, ` + feeName;
                                }
                            }
                        })
                    }

                    productTotal = productTotal + this.changeToNumber(fee.feeAmount);
                });
            }
        }
        else {
            if (this.product?.fees?.length > 0) {
                this.product?.fees.forEach((fee) => {
                    if (fee?.memberSplitable == 3) {
                        this.contract.memberfees.forEach((mem) => {
                            let isExtraMem = this.contract.members.find((item) => item?.cMMemberID == mem?.memberID).isExtraMem;
                            if (fee?.cmProductFeeID == mem?.cmProductFeeID && fee?.feeAmount > 0 && !isExtraMem) {
                                if (mem?.feeBase == 0) {
                                    isPayByEveryMem = false;
                                    feeName = `${mem?.cmFeeName}, ` + feeName;
                                }
                            }
                        })
                    }

                    productTotal = productTotal + fee?.feeAmount;
                });
            }
        }

        this.contract.memberfees.forEach((mem) => {
            memTotalFee = memTotalFee + mem.feeBase;
        });

        if (!isUnEvenPayConfirm) {
            if (productTotal != memTotalFee) {
                $('#unEqualPayConfirmModal').modal('show');
                //this._notifyService.showError(`Member fee must be equal to given product amount.`, "", 10000);
                return;
            }
        }

        if (!isPayByEveryMem) {
            this._notifyService.showError(`For ${feeName} every member must be given an amount.`, "", 10000);
            return;
        }

        if (!this.contract.cmProductID) {
            this._notifyService.showError(`Please select a product`, "", 10000);
            return;
        }

        this.showSpinner = true;
        let new_contract: boolean = false;

        if (this.contract.cmContractID <= 0) {
            new_contract = true;
        }

        this.contract.sclpUserID = this.user?.slurpyUserId > 0 ? this.user?.slurpyUserId : 0;
        this.contract.isTransfer = this.is_transfer;
        this.contract.contractTypeID = this.contractTypeID;
        this.contract.action = this.actionTypeID;
        this.contract.resnet_renew = this.resnet_renew;
        this.contract.resnet_addpaying = this.resnet_addpaying;
        this.contract.resnet_change = this.resnet_change;

        //Persist the ResNet account status captured on page open (and, for an Active
        //account, the account_id stored in reservationID). The backend guards these so
        //empty values won't overwrite an existing stored value.
        this.contract.reservationAccountStatus = this.reservationAccountStatus;
        this.contract.reservationID = this.reservationID;

        const formValue = this.siteTaxForm.value;

        const selectedSites = this.siteList
            .filter(site => formValue[`s${site.siteID}`])
            .map(site => site.siteID).join(",");


        const selectedClasses = this.cmBoatClasses
            .filter(cls => formValue[`b${cls.classID}`])
            .map(cls => cls.classID).join(",");
        this.contract.locationAccess = selectedSites;
        this.contract.boatClasses = selectedClasses;

        if (selectedSites == '') {
            this.showSpinner = false;
            this._notifyService.showError(`Please select at least one location access`, "", 10000);
            return;
        }

        await this._contractService.CMContract_Update(this.encryptedUser, this.contract).
            then(async (result: SimpleResponse) => {
                if (result) {
                    this.showSpinner = false;
                    let response = UtilityService.clone(result);
                    if (response.messageInt > 0) {
                        $('#unEqualPayConfirmModal').modal('hide');

                        if (callback) {
                            callback();
                        }
                        this.contractId = response.messageInt;

                        if (response.messageString && response.messageString.length > 0) {
                            if (!response.messageBool2)
                                this._notifyService.showHtmlSuccess(response.messageString, "Renewal", 15000);
                            else
                                this._notifyService.showError(response.messageString, "Renewal", 15000);
                        }
                        /*For Adding members CmContract Status will be (In_Progress) and member status also*/
                        if ((this.contractStatusId == eREF_CMContractStatus.OnHold_Review || this.contractStatusId == eREF_CMContractStatus.Waiting_CounterSign || this.contractStatusId == eREF_CMContractStatus.Active) && this.contract.members.filter(x => x.cMMemberID == 0).length > 0) {

                            //only once when client is opened.
                            //this.cmContractStatus(eREF_CMContractStatus.In_Progress);
                            this.contract.members.forEach((x) => {
                                if (x.cMMemberID > 0 && x.statusID == eREF_CMMemberStatus.Active && x.dtDL) {
                                    this.cmMemberStatus(eREF_CMMemberStatus.Uploaded_Drivers_License, x.contactID, x.cMMemberID)
                                }
                                else if (x.cMMemberID > 0 && x.statusID == eREF_CMMemberStatus.Active && !x.dtDL) {
                                    this.cmMemberStatus(eREF_CMMemberStatus.Payment_Complete, x.contactID, x.cMMemberID)
                                }
                            })
                        }

                        /*When Member is deleted then cmContract status will be onHold or waiting*/
                        //Read the members once and require a non-empty list. The old condition was
                        //  this.contracts[0]?.members.filter(...).length == this.contracts[0]?.members.length
                        //which, when this.contracts had not loaded yet, made BOTH sides `undefined` -
                        //and `undefined == undefined` is true. Saving a brand new contract therefore
                        //fired a Waiting_CounterSign attempt on a contract with no payments. The server
                        //correctly refused it, but every save produced a FAILED contract-log entry and
                        //an error email (see contract 6043, 2026-08-03 20:23:52).
                        const savedMembers = this.contracts[0]?.members ?? [];
                        const membersReadyToAdvance = savedMembers.filter(s => s.statusID >= eREF_CMMemberStatus.Payment_Complete && s.statusID <= eREF_CMMemberStatus.Uploaded_Drivers_License).length;

                        if ((this.contractStatusId < eREF_CMContractStatus.OnHold_Review) && savedMembers.length > 0 && membersReadyToAdvance == savedMembers.length) {
                            if (this.isContractReview) {
                                await this.cmContractStatus(eREF_CMContractStatus.OnHold_Review);
                            }
                            else {
                                await this.cmContractStatus(eREF_CMContractStatus.Waiting_CounterSign);
                            }
                        }

                        let test_mode = '';
                        let created = 'Created';

                        if (this.contract.testMode) {
                            test_mode = `<br/><b>Test Mode</b>`;
                        }

                        if (!new_contract) {
                            created = 'Updated';
                        }

                        this.Log(`Contract Saved (${created}): <b>${this.productSelectedName}</b> at ${this.siteSelectedName}<br/>Starting ${this.contract.dtContractStart} (<b>beginning ${this.contract.dtPaymentBegins}</b>) for ${this.contract.contractTerm} months<br/><b>Fees</b>: ${fees}<br/><b>Members (${this.contract.members.length})</b>: ${members}<br/><b>Terms</b>: ${this.contract.specialTerms}.${test_mode}`);

                        if (this.contractStatusId == eREF_CMContractStatus.None)
                            await this.cmContractStatus(eREF_CMContractStatus.Configured);

                        this.getContractDetails(this.contractId);
                        this.cMContractFee_Get(this.contractId, () => {
                        });

                        if (this.actionTypeID == 2 || this.actionTypeID == 3 || this.actionTypeID == 4) {
                            this.addTimeout(() => {
                                this.contractEdit = true;
                            }, 2000);
                        }
                        else {
                            this.contractEdit = false;
                        }
                        this._notifyService.showSuccess("Contract saved successfully.", "Save", 7000);
                    }
                    else {
                        this._notifyService.showError("Another version of this contract exists (or the site is not configured). Please Refresh this page and try again (or set the site).", "Save", 10000);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false
                this._globalService.error("cm-contract.SaveContract", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }


    async deleteContract() {
        this.showSpinner = true
        await this._contractService.CMContract_Delete(this.encryptedUser, this.contractId).
            then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response.messageBool) {
                        this.contractId = 0;
                        this.contracts = [];
                        this.contractEdit = false;
                        this.isValidFee = true;
                        this.isSignVisible = false
                        this.contactId = this.fromContactId
                        this.productList = []
                        this.product = <Product>{}
                        this.contacts = []
                        this.contractFees = []
                        this.fees.controls = [];
                        this.fees.removeAt(0);
                        this.feeButtonList = []
                        this.clearMembersFormArray()
                        this.getInitialContact(false);
                        this.contractType = 'New';

                        this.contractTypeForm.patchValue({
                            contractType: this.contractType,
                        });

                        this.contractStatusId = eREF_CMContractStatus.None;
                        this.contractStatusIdAdmin = eREF_CMContractStatus.None;
                        this.contractTypeID = 1;
                        this.agentForm.patchValue({
                            agentName: this.user.firstName + " " + this.user.lastName
                        });
                        this.numPaymentsForm.patchValue({
                            term: ''
                        });
                        this.termForm.patchValue({
                            term: ''
                        });
                        this.siteTaxForm.patchValue({
                            specialterms: "",
                        });
                        this.testModeForm.patchValue({
                            processorTestMode: false
                        });
                        this.upgradeForm.patchValue({
                            alreadyPaid: '',
                            alreadyPaidTax: '',
                            alreadyPaidIsTaxable: false,
                            dtAlreadyPaid: '',
                            upgradeSelected: this.upgradeSelected
                        });

                        this.cmContractType_GetList();
                        this.actionTypes_GetList();

                        this._notifyService.showSuccess("Contract deleted successfully.", "Delete", 7000);
                    }
                    this.showSpinner = false
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false
                this._globalService.error("cm-contract.DeleteContract", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
        $('#deleteContractConfirmation').modal('hide');
    }

    clearMembersFormArray() {
        this.members.controls.forEach((group: FormGroup) => {
            const memberFees = group.get('memberFees') as FormArray;

            if (memberFees) {
                memberFees.clear();
            }
        });

        this.members.clear();
    }

    EditContract() {
        if (this.contractId > 0) {
            this.contractEdit = true;
        }
    }

    cancel() {
        if (this.contractId > 0) {
            this.contractEdit = false;
            this.actionTypeID = 0;
        }
    }

    enabledDisabledLocation(item) {
        const control = this.siteTaxForm.get('s' + item.siteID);
        if (!this.contractEdit) {
            control.disable();
        } else {
            control.enable();
        }
    }
    enabledDisabledClass(item) {
        const control = this.siteTaxForm.get('b' + item.classID);
        if (!this.contractEdit) {
            control.disable();
        } else {
            control.enable();
        }
    }

    confirmDelete() {
        $('#deleteContractConfirmation').modal('show');
    }

    prepareContractForm() {
        this.contract.clpcompanyID = this.clpCompanyId;
        this.contract.clpUserID = this.user.cLPUserID;
        this.contract.agentCLPUserID = this.user.cLPUserID;
        this.contract.cmContractID = this.contractId;
        this.contract.cmProductID = this.productSelected;
        this.contract.statusID = this.contractStatusId;
        this.contract.statusIDAdmin = this.contractStatusIdAdmin;

        let class4Code = this.all_productList.filter(p => p.class4Code == this.productSelected)[0]?.class4Code;
        this.contract.class4Code = class4Code;

        this.contract.siteID = this.siteId;
        this.contract.clubID = this.clubId;
        this.contract.agentName = this.agentForm.controls["agentName"].value;
        this.contract.testMode = this.testModeForm.controls["processorTestMode"].value;

        this.contract.taxRate = this.site.taxRate;
        this.contract.dtContractEnd = this.datepipe.transform(this.siteTaxForm.controls["contractEnd"].value, 'MM-dd-yyyy');
        this.contract.dtContractStart = this.datepipe.transform(this.siteTaxForm.controls["contractStart"].value, 'MM-dd-yyyy');
        this.contract.dtPaymentBegins = this.datepipe.transform(this.siteTaxForm.controls["paymentBegin"].value, 'MM-dd-yyyy');
        this.contract.dtExpires = this.datepipe.transform(this.siteTaxForm.controls["contractExpires"].value, 'MM-dd-yyyy');
        this.contract.dtFinalPayment = this.datepipe.transform(this.siteTaxForm.controls["paymentEnd"].value, 'MM-dd-yyyy');
        this.contract.productDesc = this.siteTaxForm.controls['productDesc'].value ? this.siteTaxForm.controls['productDesc'].value : this.product?.productDesc;
        this.contract.contractTerm = this.numPaymentsForm.controls["term"].value;
        this.contract.contractTerm2 = this.termForm.controls["term"].value;
        this.contract.specialTerms = this.siteTaxForm.controls["specialterms"].value;

        if (this.isSeasonal)
            this.contract.monthsOnPlan = this.getSeasonalPlanText();

        if (!this.isEveryday)
            this.contract.daysOfWeekOnPlan = this.getWeeklyPlanText();

        this.contract.isSignUpCC = this.paymentForm.controls["isEntryCC"].value;
        this.contract.isSignUpACH = this.paymentForm.controls["isEntryACH"].value;
        this.contract.isSignUpCheck = this.paymentForm.controls["isEntryCheck"].value;
        this.contract.isSignUpCash = this.paymentForm.controls["isEntryCash"].value;
        this.contract.isMembershipCC = this.paymentForm.controls["isMonthlyCC"].value;
        this.contract.isMembershipACH = this.paymentForm.controls["isMonthlyACH"].value;
        this.contract.isMembershipCheck = this.paymentForm.controls["isMonthlyCheck"].value;

        this.contract.ccNRFee = this.ContractSetting.ccNRFee;
        this.contract.ccRFee = this.ContractSetting.ccRFee;
        this.contract.ccNRFeeIsPercent = this.ContractSetting.ccNRFeeIsPercent;
        this.contract.ccRFeeIsPercent = this.ContractSetting.ccRFeeIsPercent;
        this.contract.ccNRFeeDisclaimer = this.ContractSetting.ccNRFeeDisclaimer;
        this.contract.ccRFeeDisclaimer = this.ContractSetting.ccRFeeDisclaimer;

        this.contract.members = [];
        this.contract.fees = [];
        this.contract.memberfees = [];
        if (this.fees.value?.length > 0) {
            this.fees?.value.forEach((f, index) => {

                let tax = 0;
                const taxValue = Number(f.feeTax.match(/[\d.]+/)?.[0] || 0);
                tax = taxValue;

                var contractFee = <CMContractFee>{
                    cMContractFeeID: f.cMContractFeeID,
                    cMContractID: 0,
                    feeBase: this.changeToNumber(f.feeAmount),
                    feeTax: f.isTaxable ? tax : 0,
                    sOrder: f?.sOrder,
                    cMProductFeeID: f?.cmProductFeeID,
                    cMFeeName: f?.cmFeeName
                }

                this.contract.fees.push(contractFee);
            });
        }
        this.members.value.forEach(row => {
            //get all the fees here and add it to the member
            let mrid = localStorage.getItem(`mrid:${row.contactId}`);

            let relationshipID: number = 2;
            let explain: string = '';

            if (mrid) {
                let mridex = localStorage.getItem(`mridex:${row.contactId}`);
                relationshipID = +mrid;
                explain = mridex;
            }

            var contractMember = <CMContractMember>{
                contactID: row.contactId,
                cmContractID: this.contractId,
                cMMemberID: row.cMMemberID,
                dtContractStartLabel: 0,
                dtCreated: this.datepipe.transform(new Date(), 'MM-dd-yyyy'),
                dtCreatedLabel: '',
                dteSig: this.datepipe.transform(new Date(), 'MM-dd-yyyy'),
                dteSigLabel: '',
                eSigFullImage: '',
                eSigInitialsImage: '',
                statusID: row.statusId ? row.statusId : 1,
                statusIDAdmin: row.statusIdAdmin ? row.statusIdAdmin : 1,
                taxMembership: 0,
                taxSignUp: 0,
                //isPrimary: row.contactId == this.fromContactId ? true : false,
                isPrimary: row.isPrimary,
                dtDL: row.dtDL,
                relationshipID: relationshipID,
                explain: explain,
                isExtraMem: row?.isExtraMem ? true : (this.contractStatusId == eREF_CMContractStatus.OnHold_Review || this.contractStatusId == eREF_CMContractStatus.Waiting_CounterSign || this.contractStatusId == eREF_CMContractStatus.Active) && row.cMMemberID == 0 ? true : false
            }


            this.contract.members.push(contractMember);

            row.memberFees.forEach(f => {
                let fee_base = this.changeToNumber(f.feeBase.toString());
                let mtax = Math.round(fee_base * (this.site.taxRate / 100) * 100) / 100;

                let surcharge_rate = 0;
                let surcharge = 0;

                if (!f?.isCCOverride) {
                    if (f?.isRecurring) {
                        if (this.ContractSetting.ccRFeeIsPercent) {
                            surcharge_rate = this.ContractSetting.ccRFee / 100;
                            surcharge = f?.isTaxable ? ((fee_base + mtax) * surcharge_rate) : (fee_base * surcharge_rate);
                        }
                        else {
                            surcharge = this.ContractSetting.ccRFee;
                        }
                    }
                    else {
                        if (this.ContractSetting.ccNRFeeIsPercent) {
                            surcharge_rate = this.ContractSetting.ccNRFee / 100;
                            surcharge = f?.isTaxable ? ((fee_base + mtax) * surcharge_rate) : (fee_base * surcharge_rate);
                        }
                        else {
                            surcharge = this.ContractSetting.ccNRFee;
                        }
                    }
                }

                let cmMemberFeeID = 0;

                if (row.cMMemberID > 0) {
                    cmMemberFeeID = f.cmMemberFeeID
                }

                var memberFee = <CMMemberFee>{
                    cmMemberFeeID: cmMemberFeeID,
                    cmContractFeeID: f.cMContractFeeID,
                    cmProductFeeID: f.cmProductFeeID,
                    cmProductID: f.cmProductID,
                    memberID: row.cMMemberID,
                    contactID: row.contactId,
                    cmFeeName: f.cMFeeName,
                    feeTotal: this.changeToNumber(f.feeTotal),
                    feeTax: f.isTaxable ? mtax : 0,
                    feeSurcharge: surcharge,
                    sOrder: 0,
                    feeBase: fee_base
                }

                this.contract.memberfees.push(memberFee);
            });
        });
    }

    getSeasonalPlanText(): string {
        let plantype = '';

        if (this.isSeasonal) {
            plantype = this.siteTaxForm.controls["isJanuary"].value + "," + this.siteTaxForm.controls["isFebruary"].value + "," + this.siteTaxForm.controls["isMarch"].value + ',' + this.siteTaxForm.controls["isApril"].value + "," + this.siteTaxForm.controls["isMay"].value + "," + this.siteTaxForm.controls["isJune"].value + ',' + this.siteTaxForm.controls["isJuly"].value + "," + this.siteTaxForm.controls["isAugust"].value + "," + this.siteTaxForm.controls["isSeptember"].value + "," + this.siteTaxForm.controls["isOctober"].value + "," + this.siteTaxForm.controls["isNovember"].value + "," + this.siteTaxForm.controls["isDecember"].value;
        }

        return plantype;
    }

    getWeeklyPlanText(): string {
        let plantype = '';

        if (!this.isEveryday) {
            plantype = this.siteTaxForm.controls["isMonday"].value + "," + this.siteTaxForm.controls["isTuesday"].value + "," + this.siteTaxForm.controls["isWednesday"].value + ',' + this.siteTaxForm.controls["isThursday"].value + "," + this.siteTaxForm.controls["isFriday"].value + "," + this.siteTaxForm.controls["isSaturday"].value + ',' + this.siteTaxForm.controls["isSunday"].value;
        }

        return plantype;
    }

    getSearchData(txt, value: string = "") {
        let Search: Search = <Search>{};
        Search.searchText = txt;
        this.inputBoxValue = txt;
        Search.searchValue = "";
        this.getContactSearch(Search);
    }

    async goToLink(value: string, str: string = "") {
        if (value) {
            var id = this.searchList.filter(item => item.searchText == value)[0]?.searchValue;
            if (id?.includes("ct")) {
                this.contactId = +id?.split("ct")[1];
                this.isMemberExist = false
                await this.cMMember_Exists(this.contactId)

                if (this.isMemberExist) {
                    return this._notifyService.showError("This member already exists.", "Duplicate", 15000);
                }
                this.getContactById(this.contactId, false);
                this.autocomplete.reset();
            }
        }
        else {
            this.autocomplete.reset();
        }
    }

    //Looks up the primary contact's ResNet account on contract page open (new contracts).
    //Stores the returned account_status and, when the account is "Active", the account_id
    //(into reservationID). These are persisted with the contract on Save and used by the
    //backend ProcessResnet to decide renewal vs. new-member.
    async getResNetAccountStatusOnOpen() {
        //contractId may be 0 for a brand-new (unsaved) contract; the lookup is driven by
        //the primary contact (fromContactId), so it works before the contract exists.
        let _contactId = this.fromContactId ? this.fromContactId : this.contactId;
        if (!_contactId || _contactId <= 0) {
            return;
        }

        await this._contractService.cMContract_GetResNetAccountStatus(this.encryptedUser, this.clpCompanyId, this.contractId ? this.contractId : 0, _contactId)
            .then((result: any) => {
                if (result && result.found) {
                    this.reservationAccountStatus = result.accountStatus;

                    if (result.accountStatus && result.accountStatus.trim().toLowerCase() == 'active' && result.accountId) {
                        this.reservationID = result.accountId;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getResNetAccountStatusOnOpen", err.message, null);
            });
    }

    patchContractData() {
        this.contractId = this.contracts[0]?.cmContractID;
        this.contractStatusId = this.contracts[0]?.statusID;
        this.contractStatusIdAdmin = this.contracts[0]?.statusID;
        this.contractTypeID = this.contracts[0]?.contractTypeID;
        this.reservationID = this.contracts[0]?.reservationID;
        this.reservationAccountStatus = this.contracts[0]?.reservationAccountStatus;

        //On open, for NEW contracts only, look up the ResNet account status so it can be
        //stored with the contract and used later by ProcessResnet. Renewals/upgrades are
        //unaffected. (Brand-new, not-yet-saved contracts are handled in getContractDetailsById.)
        if (this.contractTypeID == 1) {
            this.getResNetAccountStatusOnOpen();
        }

        this.contractEndDate = this.contracts[0]?.dtContractEnd;
        this.contractTerm = this.contracts[0]?.contractTerm;
        this.contractTerm2 = this.contracts[0]?.contractTerm2;
        this.contractPaymentBegins = this.contracts[0]?.dtPaymentBegins;
        this.contractStartDate = this.contracts[0]?.dtContractStart;
        this.originalContractFinalPayment = this.contract[0]?.dtFinalPayment;

        this.productChange(this.contracts[0]?.class4Code, false, false);

        this.contractType = this.contractTypesFull.find(c => c.statusID == this.contractTypeID).status;

        this.contractTypeForm.patchValue({
            contractType: this.contractType,
        });

        this.agentForm.patchValue({
            agentName: this.contracts[0]?.agentName,
        });
        this.testModeForm.patchValue({
            processorTestMode: this.contracts[0]?.testMode,
        });
        let dtSigned = this.contracts[0]?.dtSignedMembers != '0001-01-01T00:00:00' ? this.getFormattedDate(new Date(this.contracts[0]?.dtSignedMembers)) : '';
        this.productSelected = this.contracts[0]?.class4Code;
        this.upgradeSelected = this.contracts[0]?.class4Code;

        let filtered = this.all_productList.filter(p => p.class4Code == this.productSelected);
        if (filtered) {
            this.productSelectedName = filtered[0]?.productName;
        }

        this.siteSelected = this.contracts[0]?.siteID;

        let filtered_s = this.siteList.filter(s => s.siteID == this.siteSelected);
        if (filtered_s) {
            this.siteSelectedName = filtered_s[0]?.siteName;
        }
        this.siteTaxForm.patchValue({
            specialterms: this.contracts[0]?.specialTerms,
            productDesc: this.contracts[0]?.productDesc,
            dtSignedMembers: dtSigned,
            reservationID: this.contracts[0]?.reservationID,
            contractStart: new Date(this.contracts[0]?.dtContractStart),
            contractStartLabel: this.getFormattedDate(new Date(this.contracts[0]?.dtContractStart)),
            paymentBegin: new Date(this.contracts[0]?.dtPaymentBegins),
            paymentBeginLabel: this.getFormattedDate(new Date(this.contracts[0]?.dtPaymentBegins)),
            contractExpires: new Date(this.contracts[0]?.dtExpires),
            contractExpiresLabel: this.getFormattedDate(new Date(this.contracts[0]?.dtExpires)),
            contractEnd: new Date(this.contracts[0]?.dtContractEnd),
            contractEndLabel: this.getFormattedDate(new Date(this.contracts[0]?.dtContractEnd)),
            contractSigned: this.getFormattedDate(new Date(this.contracts[0]?.dtExpires))
        });

        let numberOfPayments = this.contracts[0]?.contractTerm;
        let contractTerm = this.contracts[0]?.contractTerm2;

        let contractTermReadOnly = this.monthDiff(this.contracts[0]?.dtContractStart, this.contracts[0]?.dtContractEnd);
        let contractTermValue = contractTerm ? contractTerm : contractTermReadOnly;

        let finalPayment = this.contracts[0]?.dtFinalPayment ? this.contracts[0]?.dtFinalPayment : this.addMonthsPayments(this.contracts[0]?.dtPaymentBegins, contractTermValue);

        this.numPaymentsForm.patchValue({
            term: numberOfPayments
        });

        this.siteTaxForm.patchValue({
            paymentEnd: finalPayment,
            paymentEndLabel: this.getFormattedDate(new Date(finalPayment))
        });

        this.termForm.patchValue({
            term: this.contractTerm2 ? this.contractTerm2 : contractTermReadOnly
        });

        this.paymentForm.patchValue({
            isEntryCC: this.contracts[0]?.isSignUpCC,
            isEntryACH: this.contracts[0]?.isSignUpACH,
            isEntryCheck: this.contracts[0]?.isSignUpCheck,
            isEntryCash: this.contracts[0]?.isSignUpCash,
            isMonthlyCC: this.contracts[0]?.isMembershipCC,
            isMonthlyACH: this.contracts[0]?.isMembershipACH,
            isMonthlyCheck: this.contracts[0]?.isMembershipCheck
        });



        if (this.contracts[0]?.daysOfWeekOnPlan) {
            let _weekOfPlan = this.contracts[0]?.daysOfWeekOnPlan.split(',');
            this.siteTaxForm.patchValue({
                isMonday: this.getBool(_weekOfPlan[0]),
                isTuesday: this.getBool(_weekOfPlan[1]),
                isWednesday: this.getBool(_weekOfPlan[2]),
                isThursday: this.getBool(_weekOfPlan[3]),
                isFriday: this.getBool(_weekOfPlan[4]),
                isSaturday: this.getBool(_weekOfPlan[5]),
                isSunday: this.getBool(_weekOfPlan[6]),
            });
        }
        if (this.contracts[0]?.monthsOnPlan) {
            let _monthPlan = this.contracts[0]?.monthsOnPlan.split(',');
            this.siteTaxForm.patchValue({
                isJanuary: this.getBool(_monthPlan[0]),
                isFebruary: this.getBool(_monthPlan[1]),
                isMarch: this.getBool(_monthPlan[2]),
                isApril: this.getBool(_monthPlan[3]),
                isMay: this.getBool(_monthPlan[4]),
                isJune: this.getBool(_monthPlan[5]),
                isJuly: this.getBool(_monthPlan[6]),
                isAugust: this.getBool(_monthPlan[7]),
                isSeptember: this.getBool(_monthPlan[8]),
                isOctober: this.getBool(_monthPlan[9]),
                isNovember: this.getBool(_monthPlan[10]),
                isDecember: this.getBool(_monthPlan[11]),
            });
        }

        this.addTimeout(() => {
            // Patch Sites
            if (this.contracts[0]?.locationAccess) {
                const siteIDs = this.contracts[0]?.locationAccess.split(",");

                this.siteList.forEach(site => {
                    this.siteTaxForm.get(`s${site.siteID}`)?.setValue(false);
                });

                siteIDs.forEach(id => {
                    if (this.siteTaxForm.get(`s${id}`))
                        this.siteTaxForm.get(`s${id}`)?.setValue(true);
                });
            }
            else {
                this.siteList.forEach(site => {
                    this.siteTaxForm.get(`s${site.siteID}`)?.setValue(true);
                });
            }

            // Patch Classes
            if (this.contracts[0]?.boatClasses) {
                const classIDs = this.contracts[0]?.boatClasses.split(",");
                this.cmBoatClasses.forEach(cls => {
                    this.siteTaxForm.get(`b${cls.classID}`)?.setValue(false);
                });

                classIDs.forEach(id => {
                    if (this.siteTaxForm.get(`b${id}`))
                        this.siteTaxForm.get(`b${id}`)?.setValue(true);
                });
            }
            else {
                if (this.contracts[0]?.locationAccess) {
                    this.cmBoatClasses.forEach(cls => {
                        this.siteTaxForm.get(`b${cls.classID}`)?.setValue(false);
                    });
                }
                else {
                    this.cmBoatClasses.forEach(cls => {
                        this.siteTaxForm.get(`b${cls.classID}`)?.setValue(true);
                    });
                }
            }
        }, 200)
    }



    getFormattedDate(d: Date) {
        let curr_date = d.getDate();
        let curr_month = d.getMonth() + 1; //Months are zero based
        let curr_year = d.getFullYear();
        return curr_month + "/" + curr_date + "/" + curr_year;
    }

    confirmMemberDlt(_contactId: number, cntId: number, index) {
        $('#deleteMemberConfirmation').modal('show');
        this.memContactId = _contactId;
        this.delContactId = cntId;
        this.dltMemIndex = index
    }

    async memberDelete() {
        if (this.contracts[0]?.members.length > 0 && this.memContactId > 0) {
            /*            let memberId = this.contracts[0]?.members.filter(m => m.cMMemberID == this.memContactId)[0].cMMemberID;*/
            let del_contact = this.contacts.find(c => c.contactId == this.memContactId);

            await this._contractService.cmMemberDelete(this.encryptedUser, this.memContactId).
                then(async (result: SimpleResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        if (response.messageInt > 0) {
                            this.Log(`${del_contact?.firstName} ${del_contact?.firstName} (${this.memContactId}) was removed from the contract.`);
                            this.getContractDeletedById();
                            this.contacts = this.contacts.filter(c => c.contactId != this.delContactId).slice();
                            this.contactDetails = this.contactDetails.filter(dc => dc.contactId != this.delContactId).slice();
                            this.getContactData(true, null);
                            $('#deleteMemberConfirmation').modal('hide');
                            this._notifyService.showSuccess("The member was removed from the contract successfully.", "Delete", 7000);
                        }
                        else {
                            this._notifyService.showError("Member could not be removed from the contract.", "Not Deleted", 10000);
                            $('#deleteMemberConfirmation').modal('hide');
                        }

                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("cm-contract.memberDelete", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
        else {
            this.contacts = this.contacts.filter(c => c.contactId != this.delContactId).slice();
            this.contactDetails = this.contactDetails.filter(dc => dc.contactId != this.delContactId).slice();
            this.contactId = this.fromContactId;
            this.getContactData(true, null);
            this.members.removeAt(this.dltMemIndex);
            this._notifyService.showSuccess("The member was removed from the contract successfully.", "Delete", 7000);
            $('#deleteMemberConfirmation').modal('hide');
        }
    }

    refreshMemAmount() {
        this.siteTaxForm.get('fees')['controls'].forEach((item, index) => {
            this.onChangeFees(item, index, true);
        });
    }

    getBool(value: string): boolean {
        let isTrue: boolean = false;
        if (value.indexOf('false') > -1)
            isTrue = false;
        else
            isTrue = true;
        return isTrue;
    }

    addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    addMonthsContract(date, months) {
        var result = new Date(date);
        result.setMonth(result.getMonth() + +months);
        return result;
    }

    addMonthsPayments(date, months) {
        var result = new Date(date);
        result.setMonth(result.getMonth() + +months - 1);
        return result;
    }

    getContactSearch(searchData: Search) {
        this._searchContactService.getContactSearchData(this.encryptedUser, this.user.cLPUserID, searchData)
            .then(async (result: SearchListResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.searchList = response.searchList;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("buzz-index.getLeadHistory", err.message, null, "clpUserId " + this.user.cLPUserID + "," + "searchData " + searchData);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async saveContact() {

        this.validateAllFormFields(this.contactForm);
        if (!this.contactForm.valid)
            return;

        await this.prepareContact();

        if (this.contactForm2.controls["siteId"].value != this.siteId) {
            this._notifyService.showError('', "Secondary members must belong to the same site as the primary member.", 10000);
            return;
        }

        this.showSpinner = true;

        if (this.contactData.contactID > 0) {
            localStorage.removeItem(`mrid:${this.contactData.contactID}`);
        }

        await this._contractService.CMContact_Save(this.encryptedUser, this.contactData, 0, false).
            then(async (result: SimpleResponse) => {
                if (result) {
                    this.showSpinner = false
                    let response = UtilityService.clone(result);
                    if (response.messageInt > 0) {
                        this.contactId = response.messageInt;
                        this.getContactData(false, null);
                        this._notifyService.showSuccess(this.isEditMem ? "The member was updated. Click 'Save Contract' to save your changes." : "The member was added. Click 'Save Contract' to save your changes.", "Success", 7000);
                        this.hideModalContact();

                        localStorage.setItem(`mrid:${this.contactId}`, this.contactData.relationshipID.toString());
                        localStorage.setItem(`mridex:${this.contactId}`, this.contactData.explain.toString());

                        let upadd = 'added';
                        if (this.isEditMem) {
                            upadd = 'updated';
                        }

                        this.Log(`Member (${this.contactData.firstName} ${this.contactData.lastName}: ${this.contactData.contactID}) ${upadd}.`);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false
                this._globalService.error("cm-contract.saveContact", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    saveContactValid() {
        if (!this.isContactCreate ||
            !this.cform.txtFirstName.value || this.cform.txtFirstName.value == '' || (this.cform.txtFirstName.errors && (this.cform.txtFirstName.touched || this.cform.txtFirstName.dirty)) ||
            !this.cform.txtLastName.value || this.cform.txtLastName.value == '' || (this.cform.txtLastName.errors && (this.cform.txtLastName.touched || this.cform.txtLastName.dirty)) ||
            !this.cform.txtEmail.value || this.cform.txtEmail.value == '' || (this.cform.txtEmail.errors && (this.cform.txtEmail.touched || this.cform.txtEmail.dirty)) ||
            !this.cform.txtMobilePhone.value || this.cform.txtMobilePhone.value == '' || (this.cform.txtMobilePhone.errors && (this.cform.txtMobilePhone.touched || this.cform.txtMobilePhone.dirty))
        ) {
            return true;
        }
        else
            return false;
    }

    async prepareContact() {
        this.contactData.contactID = this.contactId;
        this.contactData.firstName = this.contactForm.controls["txtFirstName"].value;
        this.contactData.lastName = this.contactForm.controls["txtLastName"].value;
        this.contactData.email = this.contactForm.controls["txtEmail"].value;
        this.contactData.mobile = this.contactForm.controls["txtMobilePhone"].value;
        this.contactData.homePhone = this.contactForm.controls["txtHomePhone"].value;
        this.contactData.add1 = this.contactForm.controls["txtAddress"].value;
        this.contactData.city = this.contactForm.controls["txtCity"].value;
        this.contactData.zip = this.contactForm.controls["txtZip"].value;
        this.contactData.state = this.contactForm.controls["state"].value;
        this.contactData.country = this.contactForm.controls["country"].value;
        this.contactData.dl = this.contactForm2.controls["dl"].value;
        this.contactData.dob = this.contactForm2.controls["dob"].value;
        this.contactData.emergencyCName = this.contactForm2.controls["emgContactName"].value;
        this.contactData.emergencyCPhone = this.contactForm2.controls["txtEmgCntPhone"].value;
        this.contactData.siteId = this.contactForm2.controls["siteId"].value;
        this.contactData.relationshipID = this.contactForm2.controls["relationshipID"].value;
        this.contactData.explain = this.contactForm2.controls["explain"].value;

        if (this.contracts[0]?.members?.filter(i => i.isPrimary)?.length > 0) {
            await this.getPrimaryContactDetails(this.contracts[0]?.members.filter(i => i.isPrimary)[0]?.contactID);
        }
        else {
            this.contactData.cLPUserID = this.user.cLPUserID;
        }

        this.contactData.cLPCompanyID = this.user.cLPCompanyID;
    }



    openContact(newAdd: boolean) {
        $('#contactModal').modal('show');

        this.searchList = [];
        this.autocomplete.reset();

        this.contactForm2.patchValue({
            relationshipID: 2,
            explain: ''
        });

        //const defaultId = 2;

        //this.contactForm2.get('relationshipID')!
        //    .setValue(defaultId, { emitEvent: false });

        this.addTimeout(() => {
            if (this.autocomplete) {
                this.autocomplete.focus();
            }
        }, 1000);

        if (newAdd) {
            this.contactId = 0;
            this.contactForm = this.prepareContactForm();

            this.Log(`<b>Add Member</b> opened.`);
        }
    }

    hideModalContact() {
        this.isContactCreate = false;
        this.isEditMem = false
        this.Log(`<b>Edit Member</b> dialog closed.`);
        $('#contactModal').modal('hide');
    }

    contactHide() {
        if (!this.isContactCreate)
            this.isContactCreate = true;

        if (this.isContactCreate) {
            this.contactForm.reset();
            this.contactForm2.reset();
            this.contactForm.get('country').setValue('US')
            this.contactForm.get('state').setValue('')
            this.contactForm2.patchValue({
                siteId: this.siteSelected,
                site: this.siteSelectedName,
                relationshipID: 2,
                explain: '',
                isPrimary: false
            });
        }
    }


    getFee(contactId, feeType): string {
        let amount: string = '0';
        if (this.contracts && this.contracts.length > 0) {
            this.contracts[0]?.members.forEach((item) => {
                if (item.contactID == contactId) {
                    if (feeType == 's') {
                        amount = this.changeToCurrency(item.feeSignUp);
                    }
                    else {
                        amount = this.changeToCurrency(item.feeMembership);
                    }
                }
            });
        }
        else {
            if (this.contacts.length > 0) {
                if (feeType == 's') {
                    amount = this.changeToCurrency(this.contacts.filter(c => c.contactId == contactId)[0]?.signupFee);
                }
                else {
                    amount = this.changeToCurrency(this.contacts.filter(c => c.contactId == contactId)[0]?.memberFee);
                }
            }
        }
        return amount;
    }

    feeChange(fee) {
        //let total = 0
        let finalTotal = 0
        this.isValidFee = true
        let productFeeID = fee?.cMProductFeeID;

        if (productFeeID == undefined) {
            productFeeID = fee?.cmProductFeeID;

            if (productFeeID == undefined) {
                productFeeID = fee?.value?.cmProductFeeID;
            }
        }

        let feeName = fee?.cMFeeName;

        if (feeName == undefined) {

            feeName = fee?.cmFeeName;

            if (feeName == undefined) {
                feeName = fee?.value?.cmFeeName;

                if (feeName == undefined) {
                    feeName = fee?.value?.cMFeeName;
                }
            }
        }

        this.membersForm.get('members')['controls'].forEach(mem => {
            mem?.get('memberFees')['controls'].forEach(item => {
                if (item.value.cmProductFeeID == productFeeID) {
                    finalTotal = finalTotal + this.changeToNumber(item?.value?.feeBase);
                }
            });
        });
        let feeAmount = 0;


        this.siteTaxForm.get('fees')['controls'].forEach(item => {
            if (item.value.cmProductFeeID == productFeeID) {
                feeAmount = this.changeToNumber(item?.value?.feeAmount); //tax is adding at backend.
            }
        });

        if (finalTotal != feeAmount) {
            this.isValidFee = false;
        }

        if (this.actionTypeID != 2 && this.actionTypeID != 3 && this.actionTypeID != 4) {//don't validate on upgrade
            if (!this.isValidFee) {
                this._notifyService.showError(`The ${feeName} for the Members does not equal to the total ${feeName} for the Contract.`, "", 10000);
                return false;
            }
        }

        return true;
    }

    memberFeeChanges(fee, member) {
        try {
            let totalFee = this.changeToNumber(fee?.value?.feeBase);
            let equalFee = totalFee / this.contacts.length;
            this.membersForm.get('members')['controls'].forEach(mem => {
                mem?.get('memberFees')['controls'].forEach(c => {
                    if (c.value.cmProductFeeID == fee.cmProductFeeID && fee.memberSplitable == 1) {
                        if (mem?.value.contactId == this.fromContactId)
                            c.controls['feeBase'].setValue(this.changeToCurrency(this.changeToNumber(fee?.value?.feeBase)));
                    }
                    if (c.value.cmProductFeeID == fee.cmProductFeeID && fee.memberSplitable == 2)
                        c.controls['feeBase'].setValue(this.changeToCurrency(equalFee));
                    if (c.value.cmProductFeeID == fee.cmProductFeeID && fee.memberSplitable == 3)
                        c.controls['feeBase'].setValue(this.changeToCurrency(this.changeToNumber(fee?.value?.feeBase)));
                });
            });
        } catch (e) {
            console.log('memberFeeChanges', e);
        }
    }


    changeToCurrency(value: number): string {
        let final = '$0';

        if (value > 0) {
            final = `$${(Math.round(value * 100) / 100).toFixed(2)}`;
        }

        return final;
    }

    changeToNumber(value: string): number {
        if (value != null && value != undefined) {
            if (value?.toString().includes('$'))
                return Number(value?.replace(/\$/g, ''));
            else
                return Number(value);
        }
        else {
            return 0
        }
    }

    getStatus(statusId: number): string {
        var status = 'Pending';
        if (statusId) {
            switch (statusId) {
                case eREF_CMMemberStatus.None: {
                    status = "Pending";
                    break;
                }
                case eREF_CMMemberStatus.Ready_To_Send: {
                    status = "Ready To Send";
                    break;
                }
                case eREF_CMMemberStatus.Sent: {
                    status = "Sent";
                    break;
                }
                case eREF_CMMemberStatus.Registered: {
                    status = "Registered";
                    break;
                }
                case eREF_CMMemberStatus.Info_Update: {
                    status = "Info Updated";
                    break;
                }
                case eREF_CMMemberStatus.eSigned: {
                    status = "eSigned";
                    break;
                }
                case eREF_CMMemberStatus.Payment_Complete: {
                    status = "Payment Complete";
                    break;
                }
                case eREF_CMMemberStatus.Uploaded_Drivers_License: {
                    status = "Uploaded Driver's License";
                    break;
                }
                case eREF_CMMemberStatus.Active: {
                    status = "Active";
                    break;
                }
                default: {
                    status = "Pending";
                    break;
                }
            }
        }
        return status;
    }

    setEvenly(fee: FeeButton) {

        if (this.contacts && this.contacts.length > 1) {
            let feeValue = '';

            this.siteTaxForm.get('fees')['controls'].forEach(item => {
                if (item.value.cmProductFeeID == fee.cMProductFeeID) {

                    let simpleFee = 0, perFee = 0;
                    simpleFee = this.changeToNumber(item?.value?.feeAmount); //tax is adding at backend.
                    perFee = simpleFee / this.contacts.length;
                    this.membersForm.get('members')['controls'].forEach(mem => {
                        mem?.get('memberFees')['controls'].forEach(c => {
                            if (c.value.cmProductFeeID == fee.cMProductFeeID) {
                                feeValue = this.changeToCurrency(perFee)
                                c.controls['feeBase'].setValue(feeValue);
                            }
                        })
                    })
                }

            });

            this.feeChange(fee);

            this.Log(`${fee.cMFeeName} Split Evenly to ${feeValue}.`);
        }
    }

    changeMemberFee(fee) {
        try {
            let totalFee = this.changeToNumber(fee?.feeAmount);
            let equalFee = totalFee / this.contacts.length;
            this.membersForm.get('members')['controls'].forEach(mem => {
                mem?.get('memberFees')['controls'].forEach(c => {
                    if (c.value.cmProductFeeID == fee.cmProductFeeID && (fee.memberSplitable <= 2)) {
                        if (mem?.value.contactId == this.fromContactId) {
                            c.controls['feeBase'].setValue(this.changeToCurrency(this.changeToNumber(fee?.feeAmount)));
                        }
                        else {
                            c.controls['feeBase'].setValue(this.changeToCurrency(0));
                        }
                    }
                    if (c.value.cmProductFeeID == fee.cmProductFeeID && fee.memberSplitable == 3)
                        c.controls['feeBase'].setValue(this.changeToCurrency(this.changeToNumber(fee?.feeAmount)));
                });
            });
        } catch (e) {
            console.log('changeMemberFee', e);
        }
    }

    openContactForm(_contactId: number, isPrimary: boolean) {
        this.isEditMem = true
        if (this.contractEdit) {
            let _contact = this.contacts.filter(c => c.contactId == _contactId)[0];
            if (_contact) {
                this.isContactCreate = true;
                this.contactId = _contactId;
                this.patchContact(_contact, isPrimary);
                this.openContact(false);
            }
        }
    }

    redirctf2f(_contactId: number, name: string) {
        this.Log(`<b>Face to Face</b> clicked (${name}: ${_contactId}).`);

        //only once when client is opened.
        //if (this.contractStatusId < eREF_CMContractStatus.OnHold_Review && this.members.value.filter(x => x.contactId == _contactId)[0].statusId < eREF_CMMemberStatus.Payment_Complete) {
        //    this.cmContractStatus(eREF_CMContractStatus.In_Progress);
        //}
        const url = this._router.serializeUrl(
            this._router.createUrlTree([`/cm-contract-client/${_contactId}/${this.user.cLPUserID}/${this.contractId}`])
        );
        this.addTimeout(() => {
            window.open(url, '_blank');
        }, 400);
        //const baseUrl = window.location.href.replace(this._router.url, '');

        //let u = `${baseUrl}${url}`;
        //window.open(u, '_blank');
    }

    async cmContractStatus(statusID: number) {
        await this._contractService.cmContractStatusUpdate(this.encryptedUser, this.contractId, this.clpCompanyId, this.user?.cLPUserID, this.user?.slurpyUserId > 0 ? this.user?.slurpyUserId : 0, 0, -1, statusID)
            .then(async (result: SimpleResponse) => {
                if (result.messageInt == -1) {
                    this._notifyService.showError(`Contract status was not updated successfully. Payment has not been made.`, "", 10000);
                }
                else {
                    this._notifyService.showSuccess(`Contract status was updated successfully.`, "", 7000);
                }
                this.showSpinner = false
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false
                this._globalService.error("cm-contract-cmContractStatus", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async cmMemberStatus(statusID: number, contactId: number, memberId: number) {
        await this._contractService.cmMemberStatusUpdate(this.encryptedUser, this.contractId, this.user?.cLPUserID, this.user?.slurpyUserId > 0 ? this.user?.slurpyUserId : 0, contactId, 0, memberId, statusID)
            .then(async (result: SimpleResponse) => {
                if (result) {

                }
                this.showSpinner = false
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false
                this._globalService.error("cm-contract-cmMemberStatus", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }


    async sendMemberEmail(toContactID: number, i: number) {
        await this._contractService.sendMemberEmail(this.encryptedUser, toContactID, this.contractId, this.user?.cLPCompanyID, this.user?.cLPUserID, this.user?.slurpyUserId > 0 ? this.user?.slurpyUserId : 0).
            then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response.messageBool) {
                        this.emailTxtMsg = true;
                        this._notifyService.showSuccess(`Your mail was sent successfully.`, "", 7000);
                        const control = this.members.at(i).get('statusId');
                        if (control) {
                            control.setValue(2);
                        }
                    }
                    else {
                        this._notifyService.showError(`Please select an email template from contract settings & try again.`, "", 10000);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.sendMemberEmail", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async sendMemberText(toContactID: number, i: number, name: string) {
        this.txtContactId = toContactID;
        this.txtContact_i = i;
        this.textForm = this.prepareTextForm();
        this.textForm.reset();
        this.getTextMessagePH(this.user?.cLPUserID, this.txtContactId);
        this.Log(`<b>Send Contract</b> clicked (${name}: ${toContactID}).`);
    }

    private prepareTextForm(): FormGroup {
        return this.fb.group({
            txtMsg: [{ value: '' }],
            mediaURL: [{ value: '' }],
            sendEmail: [{ value: true }]
        });
    }

    async sendText() {
        let txtMsg = this.textform.txtMsg.value;
        let mediaURL = this.textform.mediaURL.value;
        let sendEmail = this.textform.sendEmail.value;

        if (txtMsg?.length > 0) {
            await this._contractService.sendMemberText(this.encryptedUser, this.txtContactId, this.contractId, this.user?.cLPCompanyID, this.user?.cLPUserID, this.user?.slurpyUserId > 0 ? this.user?.slurpyUserId : 0, txtMsg, mediaURL, sendEmail).
                then(async (result: SimpleResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        if (response.messageBool) {
                            this.emailTxtMsg = true;
                            this._notifyService.showSuccess(`Your text message was sent successfully.`, "", 7000);

                            if (sendEmail) {
                                if (response.messageBool2) {
                                    this._notifyService.showSuccess(`Your mail was sent successfully.`, "", 7000);
                                }
                                else {
                                    this._notifyService.showError(`A problem occurred sending your mail. ${response.messageString}`, "", 10000);
                                }
                            }

                            const control = this.members.at(this.txtContact_i).get('statusId');
                            if (control) {
                                control.setValue(2);
                            }

                            $('#textConfirmation').modal('hide');

                            this.Log(`Message sent (Msg: ${txtMsg}, URL: ${mediaURL}, Email: ${sendEmail}).`);
                        }
                        else {
                            this._notifyService.showError(`A problem occurred sending your text message.`, "", 10000);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("cm-contract.sendText", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async cMContractFee_Get(cmContractID: number, callback) {
        await this._contractService.cMContractFee_Get(this.encryptedUser, cmContractID).
            then(async (result: CMContractFeeListResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.contractFees = response?.contractFees;
                    if (callback) {
                        callback();
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.cMContractFee_Get", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }


    //#endregion

    isShowFee(fee) {

        let contractFee = this.contractFees?.filter((item) => item.cMContractFeeID == fee.value?.cMContractFeeID)[0];

        return contractFee?.memberSplitable == 2;
    }

    isFeeHidden(fee) {
        let productFee = <Fee>{}
        productFee = this.product?.fees?.filter((item) => item.cmProductFeeID == fee.value?.cmProductFeeID)[0];
        if (productFee?.feeAmount == 0) {
            return true;
        }

        return false;
    }

    isZeroFeeHidden(fee, card) {
        let productFee = <Fee>{}
        productFee = this.product?.fees?.filter((item) => item.cmProductFeeID == fee.value?.cmProductFeeID)[0];
        if (productFee?.feeAmount == 0) {
            if (productFee?.isCollectNow) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return !card;
        }
    }

    readonlyFeeLabel(fee) {
        let productFee = <Fee>{}
        productFee = this.product?.fees?.filter((item) => item.cmProductFeeID == fee.value?.cmProductFeeID)[0];

        if (this.actionTypeID != 2 && this.actionTypeID != 3 && this.actionTypeID != 4 && this.actionTypeID != 0 && this.actionTypeID != 6 && this.actionTypeID != 7 && this.actionTypeID != 8) {
            //if ((this.actionTypeID == 2 || this.actionTypeID == 4) && ((!productFee?.isRecurring && !productFee?.isCCOverride) || (productFee?.isRecurring && productFee?.isCCOverride))) {
            //    return true;
            //}

            return !this.contractEdit;
        }
        else {
            return true;
        }
    }

    hideLabel() {
        if (this.actionTypeID != 2 && this.actionTypeID != 3 && this.actionTypeID != 4 && this.actionTypeID != 0 && this.actionTypeID != 6 && this.actionTypeID != 7 && this.actionTypeID != 8) {//IF AN UPGRADE, DISABLE ADDING NEW MEMBERS UNTIL SAVED
            return this.contractEdit;
        }
        else {
            return false;
        }
    }

    /**
     * Returns a human-readable reason string when a member is missing email or mobile,
     * or an empty string if both are present. Used to:
     *   1. Disable the per-member "Send Contract" / "Face to Face" buttons.
     *   2. Populate the button tooltip so the user knows why the action is unavailable.
     *   3. Drive the saveContract() pre-save warning.
     */
    memberMissingContactInfo(mem: AbstractControl | FormGroup): string {
        if (!mem) return '';
        const email = (mem.get('email')?.value ?? '').toString().trim();
        const mobile = (mem.get('mobile')?.value ?? '').toString().trim();
        const missing: string[] = [];
        if (!email) missing.push('email');
        if (!mobile) missing.push('mobile');
        if (missing.length === 0) return '';
        return `Member is missing ${missing.join(' and ')}. Please update the contact before sending the contract.`;
    }

    /**
     * Returns an array of "<First Last>: missing email/mobile" strings — one per member
     * who is missing either field. Empty array means all members have both. Drives the
     * pre-save warning dialog inside saveContract().
     */
    private getMembersMissingContactInfo(): string[] {
        const memberControls = (this.membersForm?.get('members') as FormArray)?.controls ?? [];
        const issues: string[] = [];
        memberControls.forEach(ctrl => {
            const email = (ctrl.get('email')?.value ?? '').toString().trim();
            const mobile = (ctrl.get('mobile')?.value ?? '').toString().trim();
            const missing: string[] = [];
            if (!email) missing.push('email');
            if (!mobile) missing.push('mobile');
            if (missing.length > 0) {
                const first = (ctrl.get('firstName')?.value ?? '').toString().trim();
                const last = (ctrl.get('lastName')?.value ?? '').toString().trim();
                const name = (first + ' ' + last).trim() || '(unnamed member)';
                issues.push(`${name} — missing ${missing.join(' and ')}`);
            }
        });
        return issues;
    }

    hideAddMemberLabel() {
        if (this.actionTypeID != 2 &&
            this.actionTypeID != 3 &&
            this.actionTypeID != 4 &&
            //this.actionTypeID != 5 &&
            this.actionTypeID != 0 &&
            this.actionTypeID != 6 &&
            this.actionTypeID != 7) {//IF AN UPGRADE, DISABLE ADDING NEW MEMBERS UNTIL SAVED
            return this.contractEdit;
        }
        else {
            return false;
        }
    }

    readonlyFeeLabel_test(fee: any) {
        const at = this.actionTypeID;
        const pf = this.product?.fees?.find(
            (x: any) => x.cmProductFeeID === fee?.value?.cmProductFeeID
        );

        const isRecurring = pf?.isRecurring === true;        // force boolean
        const isCCOverride = pf?.isCCOverride === true;       // force boolean

        console.log('guard vals', { at, pf, isRecurring, isCCOverride, contractEdit: this.contractEdit });

        // not upgrade/etc
        if (![3, 0, 6, 7].includes(at)) {
            if ((at === 2 || at === 4) &&
                ((isRecurring && isCCOverride) ||
                    (!isRecurring && !isCCOverride))) {
                return true;
            }

            console.log('c', `fee:${fee?.value?.cmFeeName} at:${at}`);
            return !this.contractEdit;
        } else {
            console.log('d', `fee:${fee?.value?.cmFeeName} at:${at}`);
            return true;
        }
    }


    hideSplit(fee) {
        let productFee = <Fee>{}
        productFee = this.product?.fees?.filter((item) => item.cmProductFeeID == fee?.cMProductFeeID)[0];
        if (this.contractStatusId == 5 || this.contractStatusId == 6 || !this.hideLabel()) {

            //if (this.actionTypeID == 2 || this.actionTypeID == 4) {
            //    if (productFee?.isRecurring && !productFee?.isCCOverride) {
            //        return false;
            //    }
            //    else {
            //        return true;
            //    }
            //}
            //else {
            return true;
            //}
        }

        return false;
    }

    isFeeBaseReadOnly(mem, fee) {
        // fee base input is read only for fees in which payment is paid by one member only & member is not primary.
        let productFee = <Fee>{}
        productFee = this.product?.fees?.filter((item) => item.cmProductFeeID == fee.value?.cmProductFeeID)[0];

        if (!this.contractEdit) {
            return true;
        }

        if (this.contractId == 0) {
            if (productFee?.memberSplitable == 1 || productFee?.feeAmount == 0) {
                return true;
            }
        }
        else {
            let contractFee = <CMContractFee>{}
            contractFee = this.contractFees?.filter((item) => item.cMContractFeeID == fee.value?.cMContractFeeID)[0];
            if (contractFee?.memberSplitable == 1 || contractFee?.feeBase == 0) {
                return true;
            }
            else {
                if (this.contractStatusId > 2) {
                    //if (this.actionTypeID != 4) {//Add Paying Member
                    return !this.admin_override;
                    //}
                }
            }
        }

        return false;
    }

    checkMaxMem() {
        if (this.contacts?.length < this.intMaxMembers) {
            return true
        }
        else {
            return false
        }
    }

    async cMMember_Exists(contactId: number) {
        await this._contractService.cMMember_Exists(this.encryptedUser, contactId).
            then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.isMemberExist = response?.messageBool;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.cMMember_Exists", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    onChangeFees(fee, index, refresh: boolean) {
        let value = this.changeToNumber(fee.value.feeAmount) * (this.taxRate / 100);
        const feeControl = this.fees.at(index).get('feeTax') as FormControl;
        let currency = this.changeToCurrency(value)
        feeControl.setValue(currency + ' (' + this.taxRate + '%)');
        this.changeMemberFee(fee?.value);

        this.feeChange(fee);

        if (!refresh) {
            this.Log(`${fee.value.cmFeeName} changed to ${fee.value.feeAmount}.`);
        }
    }

    async checkContractPayment() {
        await this._paymentService.CMContract_isPaymentDone(this.encryptedUser, this.contractId).
            then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.isPaymentDone = response.messageInt;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.checkContractPayment", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    copyF2FUrl(_contactId) {
        const textToCopy = `${this.bcmSiteUrl}cm-contract-client/${_contactId}/${this.user.cLPUserID}/${this.contractId}`;
        navigator.clipboard.writeText(textToCopy).then(() => {
            this.membersForm.get('members')['controls'].forEach(mem => {
                if (mem.value.contactId == _contactId) {
                    mem.controls['isF2FLinkCopied'].setValue(true);
                }
            });
            this.addTimeout(() => {
                this.membersForm.get('members')['controls'].forEach(mem => {
                    if (mem.value.contactId == _contactId) {
                        mem.controls['isF2FLinkCopied'].setValue(false);
                    }
                });
            }, 2000); // Reset after 2 seconds
        }).catch(err => {
            console.error('Failed to copy text: ', err);
        });
    }

    async getTextMessagePH(userId: number, contactId: number) {
        await this._contractService.getTextMessagePH(this.encryptedUser, userId, contactId).
            then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.phSendContractMessageText = response?.messageString;
                    this.phSendContractMediaURL = response?.messageString2;

                    this.textForm.patchValue({
                        txtMsg: this.phSendContractMessageText,
                        mediaURL: this.phSendContractMediaURL,
                        sendEmail: true
                    });

                    $('#textConfirmation').modal('show');
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getTextMessagePH", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async downloadContract() {
        this.isDownloaded = true;
        this.getDownloadStatus();

    }

    getDownloadStatus() {
        this.isSubscribe = setTimeout(() => {
            this.ProcessorContractPDFConvert_GET();
            this.getDownloadStatus();
        }, 7000);
    }

    getDownloadDLStatus() {
        this.isSubscribeDL = setTimeout(() => {
            this.ProcessorDLPDFConvert_GET();
            this.getDownloadDLStatus();
        }, 7000);
    }

    async ProcessorContractPDFConvert_GET() {
        await this._contractService.ProcessorContractPDFConvert_Get(this.encryptedUser, this.clpCompanyId, this.contractId, this.fromContactId, this.siteId, true)
            .then(async (result: ContractPdfConvertContainer) => {
                if (result) {
                    this.contractPdfConvertContainer = UtilityService.clone(result);
                    if (this.contractPdfConvertContainer?.processed) {
                        clearTimeout(this.isSubscribe);
                        this.downloadContractPdf()
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.ProcessorContractPDFConvert_Get", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async downloadContractPdf() {
        this.isDownloaded = true;
        if (this.contractPdfConvertContainer?.processed) {
            await this._contractService.GetContractPDFAsync(this.encryptedUser, this.contractPdfConvertContainer?.fileName, this.contractPdfConvertContainer?.fileLength)
                .then((result: any) => {
                    if (result) {
                        let file = new Blob([result], { type: 'application/pdf' });
                        let fileURL = URL.createObjectURL(file);
                        let fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        let contactDetails = this.contactDetails?.filter(x => x.contactID == this.fromContactId)[0];
                        if (contactDetails != undefined && contactDetails != null && Object.keys(contactDetails)?.length > 0) {
                            fileLink.download = contactDetails?.firstName + '_' + contactDetails?.lastName + "_Contracts";
                            fileLink.click();
                        }
                        else {
                            this.getContactDetails((response) => {
                                fileLink.download = response?.firstName + '_' + response?.lastName + "_Contracts";
                                fileLink.click();
                            }, false);
                        }

                        this.isDownloaded = false;
                        this.Log(`Contract downloaded by ${this.user.firstName} ${this.user.lastName}.`);

                    } else {
                        console.log("exportToPDF.statusCode: Error Getting Data");
                        this.isDownloaded = false;
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this.isDownloaded = false;
                    this._utilityService.handleErrorResponse(err);
                });

        }
        else {
            this.isDownloaded = false;
            this.ProcessorContractPDFConvert_GET();
        }
    }



    async downloadDL() {
        this.isDownloadedDL = true;
        this.getDownloadDLStatus();

    }

    async ProcessorDLPDFConvert_GET() {
        await this._contractService.ProcessorDLContractPDFConvert_Get(this.encryptedUser, this.clpCompanyId, this.contractId, this.fromContactId, this.siteId)
            .then(async (result: ContractPdfConvertContainer) => {
                if (result) {
                    this.contractPdfConvertContainerDL = UtilityService.clone(result);
                    if (this.contractPdfConvertContainerDL?.processed) {
                        clearTimeout(this.isSubscribeDL);
                        this.downloadDLPdf()
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.ProcessorDLPDFConvert_GET", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async downloadDLPdf() {
        this.isDownloadedDL = true;
        if (this.contractPdfConvertContainerDL?.processed) {
            await this._contractService.GetContractPDFAsync(this.encryptedUser, this.contractPdfConvertContainerDL?.fileName, this.contractPdfConvertContainerDL?.fileLength)
                .then((result: any) => {
                    if (result) {
                        let file = new Blob([result], { type: 'application/pdf' });
                        let fileURL = URL.createObjectURL(file);
                        let fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        let contactDetails = this.contactDetails?.filter(x => x.contactID == this.fromContactId)[0];
                        if (contactDetails != undefined && contactDetails != null && Object.keys(this.contactDetails)?.length > 0)
                            fileLink.download = contactDetails?.firstName + '_' + contactDetails?.lastName + "_DL";
                        else
                            fileLink.download = "ContractDLDocuments.pdf";

                        fileLink.click();
                        this.isDownloadedDL = false;
                        this.Log(`Driver's License downloaded by ${this.user.firstName} ${this.user.lastName}.`);

                    } else {
                        console.log("exportToPDF.statusCode: Error Getting Data");
                        this.isDownloadedDL = false;
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this.isDownloadedDL = false;
                    this._utilityService.handleErrorResponse(err);
                });

        }
        else {
            this.isDownloadedDL = false;
            this.ProcessorDLPDFConvert_GET();
        }
    }


    async cmSiteEmployees_GetSigningOfficers() {
        if (this.siteId > 0) {
            await this._clubService.CMSiteEmployees_GetSigningOfficers(this.encryptedUser, this.clpCompanyId, this.siteId, this.clubId).
                then(async (result: CMSiteEmployeesListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.siteEmployeesList = response.listSiteEmployees;
                        let signingOff = this.siteEmployeesList.filter(s => s.userID == this.user?.cLPUserID && (s.siteID == this.siteId || s.siteID == 0))[0]
                        if (signingOff == null && signingOff == undefined) {
                            signingOff = this.siteEmployeesList.filter(s => s.userID == this.user?.cLPUserID)[0]
                        }
                        this.signOfficerEmpId = signingOff?.iD;
                        if (signingOff != null && signingOff != undefined && this.contractStatusId == eREF_CMContractStatus.Waiting_CounterSign) {
                            this.isSignVisible = true;
                            if (signingOff?.eSigFullImage && signingOff?.eSigFullImage != '') {
                                await this.cMSiteEmployees_Signature_Get();
                                this.initialFinalDisabled = true;
                            }

                            this.addTimeout(async () => {
                                this.resizeCanvas();
                            }, 20);
                            //else {
                            //    this.isSignCleared = true;
                            //}

                        }
                        else {
                            if (this.contractStatusId == eREF_CMContractStatus.Waiting_CounterSign) {
                                this._notifyService.showError('A signing officer is required to countersign a contract.', '', 10000);
                            }
                            this.isSignVisible = false;
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("cm_contract.CMSiteEmployees_GetSigningOfficers", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async cMSiteEmployees_Signature_Get() {
        this.isSignLoaded = false;
        await this._contractService.cMSiteEmployees_Signature_Get(this.encryptedUser, this.user?.cLPCompanyID, this.signOfficerEmpId, this.user?.cLPUserID)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response?.messageString != '' && response?.messageString != null) {
                         this.setImage(response?.messageString);
                        this.isSignUpdate = false;
                        await this.drawClearFinal();
                        this.patchSignature('data:image/png;base64,' + response?.messageString);
                        this.initialFinalDisabled = true;
                    }
                    else {
                        this.isSignUpdate = true;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.isSignLoaded = true;
                this._globalService.error("cm-contract.Log", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }
    setImage(base64: string) {
        if (!base64) return;

        this.imageSrc = `data:image/png;base64,${base64}`;
    }

    patchSignature(dataUrl: string) {
        this.addTimeout(() => {
            this.signaturePadFinal.fromDataURL(dataUrl);
            if (dataUrl != '')
                this.signaturePadFinal.off();
            this.isSignLoaded = true;
        }, 2000);
    }

    async Log(message: string) {
        let log: CMContractLog = {
            sessionID: '',
            clpUserID: this.user?.cLPUserID,
            sclpUserID: this.user?.slurpyUserId > 0 ? this.user?.slurpyUserId : 0,
            contactID: 0,
            cmContractID: this.contractId,
            isFaceToFace: -1,
            notes: message
        }
        await this._contractService.CMContractLog_Create(this.encryptedUser, log)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.Log", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    openLog(type) {
        let url = ''
        switch (type) {
            case 'contract':
                url = `cm-contract-log/${this.contractId}?r=${this.encryptedUser}`
                this.addTimeout(() => {
                    window.open(url, '_blank');
                }, 400);
                break;
            case 'activity':
                url = `cm-activity-log/${this.contractId}?r=${this.encryptedUser}`
                this.addTimeout(() => {
                    window.open(url, '_blank');
                }, 400);
                break;
        }
    }

    async archive() {
        await this._contractService.ProcessorContractPDFConvert_Archive(this.encryptedUser, this.clpCompanyId, this.contractId, this.fromContactId, this.siteId, true)
            .then(async (result: ContractPdfConvertContainer) => {
                if (result) {
                    this._notifyService.showSuccess("The pdf document for this contract has been archived.", "", 5000);
                    this.Log(`PDF Document archived by ${this.user?.slurpyName}.`);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.ProcessorDLPDFConvert_GET", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async review() {
        this.isReview = true;
        await this.cmContractStatus(eREF_CMContractStatus.Waiting_CounterSign);
        await this.refreshContract();
        this.isReview = false;

    }

    get cform() { return this.contactForm.controls; }

    get textform() { return this.textForm.controls; }

    get members(): FormArray {
        return this.membersForm.get("members") as FormArray
    }

    get memberFees(): FormArray {
        return (this.membersForm.controls["members"] as FormArray).controls['memberFees'] as FormArray
    }

    get fees(): FormArray {
        return this.siteTaxForm.get("fees") as FormArray
    }

    isShowDLDownload() {
        if (this.contracts?.length > 0 && this.contracts[0]?.members?.length > 0) {
            let isAllMem = this.contracts[0]?.members?.some(item => item?.statusID < 7);
            if (this.contractStatusId == eREF_CMContractStatus.Active && !isAllMem) {
                return false;
            }
        }
        return true;
    }


    initialFinalOnPress(e) {
        if (e.key == "Backspace" || e.key == "Delete") {
            if (this.initialFinalSignature.length == 0) {
                this.signaturePadFinal.on();
            }
            return;
        }
        this.signaturePadFinal.off();
    }

    async cmContractStatus_GetList() {
        await this._contractService.cmContractStatus_GetList(this.encryptedUser)
            .then(async (result: REF_CMStatusResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.contractStatuses = response.cmStatusList;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.cmContractStatus_GetList", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async cmMemberStatus_GetList() {
        await this._contractService.cmMemberStatus_GetList(this.encryptedUser)
            .then(async (result: REF_CMStatusResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.memberStatuses = response.cmStatusList;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.cmMemberStatus_GetList", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async cmContractType_GetList() {

        await this._contractService.cmContractType_GetList(this.encryptedUser)
            .then(async (result: REF_CMStatusResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    let list = response.cmStatusList;
                    this.contractTypesFull = list;

                    //NOT ACTIVE
                    if (this.contractStatusId < 6) {
                        const idsToRemove = [2, 3, 4];//Renewal, Upgrade, Downgrade
                        list = list.filter(s => !idsToRemove.includes(s.statusID));
                    }

                    //ACTIVE
                    if (this.contractStatusId == 6) {
                        const idsToRemove = [1];
                        list = list.filter(s => !idsToRemove.includes(s.statusID));
                    }

                    this.contractTypes = list;
                    let ct: REF_CMStatus = this.contractTypes.find(c => c.statusID == 0);

                    if (ct != null && ct != undefined) {
                        this.contractType = ct.status;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.cmContractType_GetList", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async actionTypes_GetList() {

        let types = [...this.actionTypesReset].sort((a, b) => a.sOrder - b.sOrder);

        //NOT ACTIVE
        if (this.contractStatusId < 6) {
            if (this.contractStatusId < 5) {
                const idsToRemove = [2, 3, 4, 5, 6, 8];//remove Renewal, Upgrade, Add Paying Member, Add Non Paying Member, Mark as Transfer
                types = types.filter(s => !idsToRemove.includes(s.statusID));
                this.actionTypeID = 1;
            }

            if (this.contractStatusId >= 4 && this.contractStatusId <= 5) {//OnHold_Review, Waiting_CounterSign
                const idsToRemove = [1, 2, 3, 4, 6, 7, 8, 9];//remove everything except new Change
                types = types.filter(s => !idsToRemove.includes(s.statusID));
                this.actionTypeID = 5;
            }

            if (this.contractTypeID == 5) {//TRANSFER
                this.actionTypeID = 7;
            }
        }

        //ACTIVE
        if (this.contractStatusId == 6) {
            const idsToRemove = [1, 5, 7];//remove Create New, Create New Transfer
            types = types.filter(s => !idsToRemove.includes(s.statusID));
            this.actionTypeID = 0;

            if (this.contractTypeID == 5) {//TRANSFER
                this.actionTypeID = 6;
            }
        }

        if (this.productSelectedName && this.productSelectedName.indexOf('RESNET Unknown') > -1) {
            const idsToRemove = [5, 8, 6, 9];//remove Add Non-Paying Member and Mark as Transfer (for now, Terminate) TODO
            types = types.filter(s => !idsToRemove.includes(s.statusID));
            this.actionTypeID = 0;

            const item = types.find(s => s.status === 'Add Paying Member');
            if (item) item.status = 'Add Member';
            this.paying = '';
        }

        this.actionTypes = types;
    }

    async memRelationships_GetList() {
        if (this.localService.refMem_GetAllResponse?.ref_MemSubscriptionType_List === null ||
            this.localService.refMem_GetAllResponse?.ref_MemSubscriptionType_List === undefined) {
            await this.localService.GetAll_REFs(this.encryptedUser, this.user?.cLPCompanyID);
        }

        if (this.localService.refMem_GetAllResponse != null && this.localService.refMem_GetAllResponse != undefined) {
            let rs = this.localService.refMem_GetAllResponse.ref_MemAssociationToPrimaryCaptain_List;
            this.relationshipStatus = rs;

            const defaultId = 2;

            if (rs.some(x => x.statusID === defaultId)) {
                this.contactForm2.get('relationshipID')!
                    .setValue(defaultId, { emitEvent: false });
            }
        }
    }

    sendToReservation() {
        this.disable_send = true;
        let empAccept = {} as CMSiteEmployeesAccept;
        empAccept.cLPUserId = this.user.cLPUserID;
        empAccept.contactId = this.contactId;
        empAccept.sCLPUserId = this.user?.slurpyUserId > 0 ? this.user?.slurpyUserId : 0;
        empAccept.cmContractID = this.contractId;
        empAccept.cLPCompanyID = this.user?.cLPCompanyID;
        this.showSpinner = true;
        this.Log(`Send to Reservation clicked.`);
        this._contractService.sendToReservation(this.encryptedUser, empAccept)
            .then(async (result: SimpleResponse) => {
                if (result?.messageBool) {
                    this.refreshContract();

                    if (result?.messageString != '')
                        this._notifyService.showSuccess("Sent to reservation successfully.", "", 7000);
                    else {
                        this._notifyService.showError("Failed to send to reservation. Our team has been notified.", "Reservation Error", 15000);
                    }
                }
                else {
                    this._notifyService.showError("Failed to send to reservation: " + result.messageString, "Reservation Error", 15000);
                }
                this.showSpinner = false;
                this.disable_send = false;
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("cm-contract.sendToReservation", err.message, null);
                this._utilityService.handleErrorResponse(err);
                this.disable_send = false;
            });
    }

    async upgradeContract() {
        this.upgradeConfirmed = true;

        this.upgradeSelected = this.upgradeForm.controls['upgradeSelected'].value;
        let dtAlreadyPaid = this.upgradeForm.controls['dtAlreadyPaid'].value;
        let cmUpgradeClass4Code = this.all_productList.filter(p => p.class4Code == this.upgradeSelected)[0]?.class4Code;

        this.productChange(cmUpgradeClass4Code, false, false);
        this.contract.cmUpgradeClass4Code = cmUpgradeClass4Code;
        this.contract.originalCMContractID = this.contractId;
        this.contract.originalReservationID = this.reservationID;
        this.contract.originalContractEnd = this.contractEndDate;
        this.contract.originalContractTerm = this.contractTerm;
        this.contract.originalContractTerm2 = this.contractTerm2;
        this.contract.originalPaymentBegins = this.contractPaymentBegins;
        this.contract.originalContractStart = this.contractStartDate;
        this.contract.originalContractFinalPayment = this.originalContractFinalPayment;
        this.contract.dtAlreadyPaid = dtAlreadyPaid;
        this.contractTypeID = 3;

        this.saveContract(() => {
            $('#upgradeContractConfirmation').modal('hide');
            this.getInitialContact(false);
            this.upgradeConfirmed = false;
            this.addTimeout(() => {
                this.refreshContract(true);
            }, 1000);
        });
    }

    renewContract() {
        this.renewConfirmed = true;

        this.upgradeSelected = this.upgradeForm.controls['upgradeSelected'].value;
        let dtAlreadyPaid = this.upgradeForm.controls['dtAlreadyPaid'].value;
        let cmUpgradeClass4Code = this.all_productList.filter(p => p.class4Code == this.upgradeSelected)[0]?.class4Code;

        this.productChange(cmUpgradeClass4Code, false, false);
        this.contract.cmUpgradeClass4Code = cmUpgradeClass4Code;
        this.contract.originalCMContractID = this.contractId;
        this.contract.originalReservationID = this.reservationID;
        this.contract.originalContractEnd = this.contractEndDate;
        this.contract.originalContractTerm = this.contractTerm;
        this.contract.originalContractTerm2 = this.contractTerm2;
        this.contract.originalPaymentBegins = this.contractPaymentBegins;
        this.contract.originalContractStart = this.contractStartDate;
        this.contract.originalContractFinalPayment = this.originalContractFinalPayment;
        this.contract.dtAlreadyPaid = dtAlreadyPaid;
        this.contractTypeID = 2;

        this.saveContract(() => {
            $('#renewContractConfirmation').modal('hide');
            this.getInitialContact(false);
            this.renewConfirmed = false;
            this.addTimeout(() => {
                this.refreshContract(true);
            }, 1000);
        });
    }

    addPMContract() {
        this.addPMConfirmed = true;

        this.upgradeSelected = this.upgradeForm.controls['upgradeSelected'].value;
        let dtAlreadyPaid = this.upgradeForm.controls['dtAlreadyPaid'].value;
        let cmUpgradeClass4Code = this.all_productList.filter(p => p.class4Code == this.upgradeSelected)[0]?.class4Code;

        this.productChange(cmUpgradeClass4Code, false, false);
        this.contract.cmUpgradeClass4Code = cmUpgradeClass4Code;
        this.contract.originalCMContractID = this.contractId;
        this.contract.originalReservationID = this.reservationID;
        this.contract.originalContractEnd = this.contractEndDate;
        this.contract.originalContractTerm = this.contractTerm;
        this.contract.originalContractTerm2 = this.contractTerm2;
        this.contract.originalPaymentBegins = this.contractPaymentBegins;
        this.contract.originalContractStart = this.contractStartDate;
        this.contract.originalContractFinalPayment = this.originalContractFinalPayment;
        this.contract.dtAlreadyPaid = dtAlreadyPaid;
        this.contractTypeID = 3;

        this.saveContract(() => {
            $('#addPMContractConfirmation').modal('hide');
            this.getInitialContact(false);
            this.addPMConfirmed = false;
            this.addTimeout(() => {
                this.refreshContract(true);
            }, 1000);
        });
    }

    terminatePlan() {
        this.terminateConfirmed = true;

        let terminateClass4Code = this.productSelected;

        this.contract.cmUpgradeClass4Code = terminateClass4Code;
        this.contract.originalCMContractID = this.contractId;
        this.contract.originalReservationID = this.reservationID;
        this.contract.originalContractEnd = this.contractEndDate;
        this.contract.originalContractTerm = this.contractTerm;
        this.contract.originalContractTerm2 = this.contractTerm2;
        this.contract.originalPaymentBegins = this.contractPaymentBegins;
        this.contract.originalContractStart = this.contractStartDate;
        this.contract.originalContractFinalPayment = this.originalContractFinalPayment;
        this.contractTypeID = 8;

        this.saveContract(() => {
            $('#terminatePlanConfirmation').modal('hide');
            this.getInitialContact(false);
            this.terminateConfirmed = false;
            this.addTimeout(() => {
                this.refreshContract(true);
            }, 1000);
        });
    }

    async changeContract() {
        this.changeConfirmed = true;

        //this.upgradeSelected = this.upgradeForm.controls['upgradeSelected'].value;
        //let dtAlreadyPaid = this.upgradeForm.controls['dtAlreadyPaid'].value;
        //let cmUpgradeClass4Code = this.all_productList.filter(p => p.class4Code == this.upgradeSelected)[0]?.class4Code;

        //this.productChange(cmUpgradeClass4Code, false, false);
        //this.contract.cmUpgradeClass4Code = cmUpgradeClass4Code;
        this.contract.originalCMContractID = this.contractId;
        this.contract.originalReservationID = this.reservationID;
        this.contract.originalContractEnd = this.contractEndDate;
        this.contract.originalContractTerm = this.contractTerm;
        this.contract.originalContractTerm2 = this.contractTerm2;
        this.contract.originalPaymentBegins = this.contractPaymentBegins;
        this.contract.originalContractStart = this.contractStartDate;
        this.contract.originalContractFinalPayment = this.originalContractFinalPayment;
        //this.contract.dtAlreadyPaid = dtAlreadyPaid;
        this.contractTypeID = 5;

        this.saveContract(() => {
            $('#changeContractConfirmation').modal('hide');
            this.getInitialContact(false);
            this.changeConfirmed = false;
            this.addTimeout(() => {
                this.refreshContract(true);
            }, 1000);
        });
    }

    async getCMClassList() {
        await this._productService.cmBoatClasses_GETLIST(this.encryptedUser).
            then(async (result: CMBoatClassesResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.cmBoatClasses = response?.cmBoatClasses
                    this.setValidationOfClasses();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("site-fields.getCMClassList", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async changePlan() {
        this.changeContractPlan = true;
        this.saveContract(() => {
            if (this.changeContractPlan) {
                this.changeContractPlan = false;
                $('#changePlanConfirmation').modal('hide');
            }
        });
    }

    async typeChange(statusID) {
        this.resnet_addpaying = false;
        this.resnet_renew = false;
        this.resnet_change = false;

        switch (statusID) {
            case 1: {
                if (this.contracts[0]?.contractTypeID == 5) {
                    this.contractTypeID = 1;
                }
            }
                break;
            case 2: {//renew
                if (this.productSelectedName.indexOf('RESNET Unknown') > -1) {
                    this.resnet_renew = true;
                }
            }
                break;
            case 3: {//change
                if (this.productSelectedName.indexOf('RESNET Unknown') > -1) {
                    this.resnet_change = true;
                }
            }
                break;
            case 4: {//add paying member
                if (this.productSelectedName.indexOf('RESNET Unknown') > -1) {
                    this.resnet_addpaying = true;
                }
                //else {
                //    this.openContact(true);
                //}
            }
                break;
            case 8: {//add nonpaying member
                this.openContact(true);
            }
                break;
            case 9: { //terminate
                await this._contractService.cMContract_CheckForReservationId(this.encryptedUser, this.clpCompanyId, this.contractId, statusID).
                    then(async (result: SimpleResponse) => {
                        if (result) {
                            let response = UtilityService.clone(result);
                            if (response.messageBool) {
                                this._notifyService.showHtmlSuccess(response.messageString, "Check RESNET", 10000);

                                const terminateProduct = this.productList.find(p =>
                                    p.productName.toLowerCase().includes("terminate") ||
                                    p.productName.toLowerCase().includes("termination")
                                );

                                // If found, set it as the selected value
                                if (terminateProduct) {
                                    this.productSelected = terminateProduct.class4Code;
                                    this.productChange(this.productSelected, false, false);
                                }
                                else {
                                    this._notifyService.showError(`In order to terminate this account, a product must exist at this site that contains the word 'Terminate'`, "Check RESNET", 10000);
                                    this.contractTypeID = 1;
                                    this.contractType = this.contractTypesFull.find(c => c.statusID == this.contractTypeID).status;
                                    this.actionTypeID = 0;
                                }
                            }
                            else {
                                this._notifyService.showError(response.messageString, "Check RESNET", 10000);
                                this.contractTypeID = 1;
                                this.contractType = this.contractTypesFull.find(c => c.statusID == this.contractTypeID).status;
                                this.actionTypeID = 0;
                            }
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        this._globalService.error("cm-contract.typeChange", err.message, null,
                        );
                        this._utilityService.handleErrorResponse(err);
                    });
            }
                break;
            //case 5: //Renew
            //case 10: //Existing
            //case 11: {//AddPayingMember RESNET
            //    await this._contractService.cMContract_CheckForReservationId(this.encryptedUser, this.contactId, statusID).
            //        then(async (result: SimpleResponse) => {
            //            if (result) {
            //                let response = UtilityService.clone(result);
            //                if (response.messageBool) {
            //                    this._notifyService.showHtmlSuccess(response.messageString, "Check RESNET", 10000);
            //                }
            //                else {
            //                    this._notifyService.showError(response.messageString, "Check RESNET", 10000);
            //                    this.contractTypeID = 1;
            //                    this.contractType = this.contractTypesFull.find(c => c.statusID == this.contractTypeID).status;
            //                    this.actionTypeID = 1;
            //                }
            //            }
            //        })
            //        .catch((err: HttpErrorResponse) => {
            //            this._globalService.error("cm-contract.typeChange", err.message, null,
            //            );
            //            this._utilityService.handleErrorResponse(err);
            //        });
            //}
            //    break;
            case 6:
            case 7: {//Transfers
                this.contractTypeID = 5;
            }
                break;
        }
    }

    setValidationOfSite() {
        this.siteList.forEach(site => {
            this.siteTaxForm.addControl(`s${site.siteID.toString()}`, new FormControl(true));
        });
    }

    setValidationOfClasses() {
        this.cmBoatClasses.forEach(bclass => {
            this.siteTaxForm.addControl(`b${bclass.classID.toString()}`, new FormControl(true));
        });
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    isActionHidden() {
        if ((this.actionTypeID == 2 || this.actionTypeID == 3 || this.actionTypeID == 4)) {
            return true;
        }
        else
            return false;
    }

    getRESNETContractDescription() {
        this._contractService.cmContract_Get_RESNET_Contract_Notes(this.encryptedUser, this.contractId)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.resnet_contract = response.messageString;

                    if (this.resnet_contract.length != 0) {
                        $('#resnetContractModal').modal('show');
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getRESNETContractDescription", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    monthDiff(s1: string, s2: string): number {
        const d1 = new Date(s1);
        const d2 = new Date(s2);

        return (d2.getFullYear() - d1.getFullYear()) * 12 +
            (d2.getMonth() - d1.getMonth());
    }

    addMonths(date: Date, months: number): Date {
        const d = new Date(date);
        d.setMonth(d.getMonth() + months);
        return d;
    }

    inputIsBeforeDate(input: Date, beforeDate: Date) {
        beforeDate.setHours(0, 0, 0, 0);

        const d = new Date(input);
        d.setHours(0, 0, 0, 0);

        return d < beforeDate;
    }

    processSubscriptions() {
        this.disable_send = true;
        let empAccept = {} as CMSiteEmployeesAccept;
        empAccept.cLPUserId = this.user.cLPUserID;
        empAccept.contactId = this.contactId;
        empAccept.sCLPUserId = this.user?.slurpyUserId > 0 ? this.user?.slurpyUserId : 0;
        empAccept.cmContractID = this.contractId;
        empAccept.cLPCompanyID = this.user?.cLPCompanyID;
        this.showSpinner = true;
        this.Log(`Subscriptions clicked.`);
        this._contractService.processSubscriptions(this.encryptedUser, empAccept)
            .then(async (result: SimpleResponse) => {
                if (result?.messageBool) {
                    this.refreshContract();

                    if (result?.messageString != '')
                        this._notifyService.showSuccess("Processed Subscriptions successfully.", "", 7000);
                    else {
                        this._notifyService.showError("Failed to process Subscriptions. Our team has been notified.", "Subscriptions Error", 15000);
                    }
                }
                else {
                    this._notifyService.showError("Failed to process Subscriptions: " + result.messageString, "Subscriptions Error", 15000);
                }
                this.showSpinner = false;
                this.disable_send = false;
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("cm-contract.processSubscriptions", err.message, null);
                this._utilityService.handleErrorResponse(err);
                this.disable_send = false;
            });
    }

    processEmails() {
        this.disable_send = true;
        let empAccept = {} as CMSiteEmployeesAccept;
        empAccept.cLPUserId = this.user.cLPUserID;
        empAccept.contactId = this.contactId;
        empAccept.sCLPUserId = this.user?.slurpyUserId > 0 ? this.user?.slurpyUserId : 0;
        empAccept.cmContractID = this.contractId;
        empAccept.cLPCompanyID = this.user?.cLPCompanyID;
        this.showSpinner = true;
        this.Log(`Emails clicked.`);
        this._contractService.processEmails(this.encryptedUser, empAccept)
            .then(async (result: SimpleResponse) => {
                if (result?.messageBool) {
                    this.refreshContract();

                    if (result?.messageString != '')
                        this._notifyService.showSuccess("Processed Emails successfully.", "", 7000);
                    else {
                        this._notifyService.showError("Failed to process Subscriptions. Our team has been notified.", "Subscriptions Error", 15000);
                    }
                }
                else {
                    this._notifyService.showError("Failed to process Subscriptions: " + result.messageString, "Subscriptions Error", 15000);
                }
                this.showSpinner = false;
                this.disable_send = false;
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("cm-contract.processEmails", err.message, null);
                this._utilityService.handleErrorResponse(err);
                this.disable_send = false;
            });
    }
}
